import { Suspense } from "react";
import { Navigate } from "react-router-dom";

import PassRate from "./components/pass-rate/PassRate";
import Dashboard from "./components/dashboard/Dashboard";
import DistrictData from "./components/management-data/district-data/DistrictData";
import StudentData from "./components/management-data/student-data/StudentData";
import TeacherData from "./components/management-data/teacher-data/TeacherData";
import SyllabusReports from "./components/syllabus-reports/SyllabusReports";
import StudentReports from "./components/student-reports/StudentReports";
import StudentDetail from "./components/student-reports/StudentDetail";
import Demographics from "./components/Demographics/Demographics";
import TeacherReports from "./components/TeacherReports/TeacherReports";
import GradeDistribution from "./components/GradeDistribution/GradeDistribution";
import SupportAdmin from "./components/support-admin/SupportAdmin";
import Newuser from "./components/new-user/NewUser";
import AiceReports from "./components/aice-reports/AiceReports";
import ManageResultsDelay from "./components/manage-results-delay/ManageResultsDelay";
import moment from "moment-timezone";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

export const constants = {
  newUser: {
    header: "WELCOME TO REPORT MAKER",
    sec1: "Our terms and conditions for this website",
    btn: "Yes, I agree",
  },
  passRate: {
    examHeader: "PASS RATES",
    districtHeader: "PASS RATES BY SCHOOL",
    stateHeader: "PASS RATES BY DISTRICT",
    stateHeaderForDistrict: "PASS RATES",
    cambridgeGradesLink:
      "https://www.cambridgeinternational.org/usa/about-cambridge-international-us/guide-to-cambridge-grades/",
    subHeader:
      "AS & A Level grades are awarded on a scale from A* (A Level) or A (AS Level) to E. A grade of E is considered passing and a grade of C or higher represents stronger performance. IGCSE grades are awarded on a scale from A* to G. Learn more in the",
    commonSubHead:
      "Pass rates for students who received a grade. Learn more in the",
    stateAndDistrictSubHead:
      "AS & A Level grades are awarded on a scale from A* (A Level) or A (AS Level) to E. IGCSE grades are awarded on a scale from A* to G. Learn more in the",
    emptyMsg: "no pass rate details were found.",
    tableSubHead: [
      {
        colSpan: 1,
        class: "w-25",
        col: "sylID",
        label: "Syllabus",
        id: "sylId",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        colSpan: 1,
        class: "w-35",
        col: "passRate",
        label: "Pass rate",
        id: "gte_progress",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        class: "bg_grey w-5",
        col: "exams",
        label: "Exams",
        id: "exams",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        class: "head_bg_yellow w-5",
        col: "passRateC",
        label: "gtc",
        id: "schoolPassRate",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        class: "head_bg_blue w-5",
        col: "passRate",
        label: "gte",
        id: "schoolGte",
        sortVisible: true,
        sortOrder: "asc",
      },
      {
        class: "w-5",
        col: "natPassRateC",
        label: "gtc",
        id: "nationalPassRate",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        class: "w-5",
        col: "natPassRate",
        label: "gte",
        id: "nationalGte",
        sortVisible: false,
        sortOrder: "asc",
      },
    ],
    districtBySchoolSubHeads: [
      {
        colSpan: 1,
        class: "w-25",
        col: "sylID",
        label: "Syllabus",
        id: "sylId",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        colSpan: 1,
        class: "w-35",
        col: "passRate",
        label: "Pass rate",
        id: "gte_progress",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        class: "bg_grey w-5 text-center",
        col: "exams",
        label: "Exams",
        id: "exams",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        class: "head_bg_blue w-5 text-center",
        col: "passRate",
        label: "gte",
        id: "schoolGte",
        sortVisible: true,
        sortOrder: "asc",
      },
      {
        class: "w-5 text-center",
        col: "natPassRate",
        label: "gte",
        id: "nationalPassRate",
        sortVisible: false,
        sortOrder: "asc",
      },
    ],
    districtTableHeaders: [
      {
        label: "School",
        class: "",
        col: "centreID",
        id: "centreId",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        label: "Pass rate",
        class: "",
        col: "passRate",
        id: "gte_progress",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        label: "Exams",
        class: "bg_grey text-center w-5",
        col: "exams",
        id: "exams",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        label: "gte",
        class: "head_bg_blue text-center w-5",
        col: "passRate",
        id: "schoolGte",
        sortVisible: true,
        sortOrder: "asc",
      },
    ],
    stateTableHeaders: [
      {
        label: "District",
        class: "",
        col: "districtName",
        id: "districtName",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        label: "Pass rate",
        class: "",
        col: "passRate",
        id: "gte_progress",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        label: "Exams",
        class: "bg_grey text-center w-5",
        col: "exams",
        id: "exams",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        label: "gte",
        class: "head_bg_blue text-center w-5",
        col: "passRate",
        id: "schoolGte",
        sortVisible: true,
        sortOrder: "asc",
      },
    ],
    dropDownLabels: {
      series: "EXAM SERIES",
      qual: "QUALIFICATION",
    },
  },
  syllabusReports: {
    header: "syllabus grades and marks",
    subHeader:
      "View syllabus and component grades and marks for all students. ",
    cardSubHeader: "Cambridge International AS & A Level",
    understandingResults:
      "https://www.cambridgeinternational.org/support-and-training-for-schools/support-for-teachers/results/understanding-results/",
    aice_qulification:
      "https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-advanced/cambridge-aice-diploma/qualification",
    dropDownLabels: {
      series: "EXAM SERIES",
      qual: "SYLLABUS",
    },
  },
  teacherData: {
    teacherHeaders: [
      {
        col: "syllabus",
        label: "Syllabus",
        id: "syllabus",
        sortVisible: true,
        sortOrder: "asc",
      },
      {
        col: "syllabusName",
        label: "Syllabus name",
        id: "syllabusName",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        col: "mail",
        label: "Teacher",
        id: "mail",
        sortVisible: false,
        sortOrder: "asc",
      },
    ],
  },
  studentReports: {
    header: "STUDENT RECORDS",
    subHeader: "View all student records with added data where provided.",
    disSubHeaader: "Detailed reports for students within your district",
    teacherSub: "Detailed reports for students you have taught",
    emptyMsg: "No results match your search criteria. Please try again.",
    tableHeaders: [
      {
        class: "",
        col: "centreID",
        label: "Centre",
        id: "centre",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        class: "",
        col: "candidateNumber",
        label: "Number",
        id: "candNumber",
        sortVisible: true,
        sortOrder: "asc",
      },
      {
        class: "text-nowrap",
        col: "studentName",
        label: "Student name",
        id: "stuName",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        class: "text-nowrap",
        col: "nationalId",
        label: "National ID",
        id: "natId",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        class: "text-nowrap",
        col: "studentStateId",
        label: "Student State ID",
        id: "stuStateId",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        class: "text-nowrap",
        col: "graduationYear",
        label: "Graduation year",
        id: "gradYear",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        class: "text-nowrap",
        col: "ethnicity",
        label: "Ethinicity / Race",
        id: "ethnicity",
        sortVisible: false,
        sortOrder: "asc",
      },
    ],
    dropDownLabels: {
      series: "EXAM SERIES",
      searchLabel: "SEARCH STUDENTS",
    },
    StudentDetail: {
      tableHeaders: [
        {
          class: "",
          col: "",
          label: "Exam series",
          id: "series",
          sortVisible: false,
          sortOrder: "asc",
        },
        {
          class: "",
          col: "candFN",
          label: "Code",
          id: "syllabusCode",
          sortVisible: true,
          sortOrder: "asc",
        },
        {
          class: "",
          col: "",
          label: "Syllabus",
          id: "syllabusName",
          sortVisible: false,
          sortOrder: "asc",
        },
        {
          class: "",
          col: "",
          label: "Qualification",
          id: "qualification",
          sortVisible: false,
          sortOrder: "asc",
        },
        {
          class: "",
          col: "",
          label: "Level entered",
          id: "levelEntered",
          sortVisible: false,
          sortOrder: "asc",
        },
        {
          class: "",
          col: "",
          label: "Level achieved",
          id: "levelAchieved",
          sortVisible: false,
          sortOrder: "asc",
        },
        {
          class: "",
          col: "",
          label: "Grade",
          id: "grade",
          sortVisible: false,
          sortOrder: "asc",
        },
      ],
      icon: {
        back: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 96 960 960"
            width="24">
            <path d="M560.615 802.153 333.847 575.385l226.768-227.153 32.615 32.614-194.154 194.539L593.23 769.538l-32.615 32.615Z"></path>
          </svg>
        ),
      },
    },
  },
  dashboard: {
    header1: "Pass rates snapshot",
    header2: "online School reports",
    subHeader2: "Basic reports for your school",
    downloadLabel: "download school data",
    downloadDistrictLabel: "download district reports",
    downloadStateLabel: "download state reports",
    teacherReportLabel: "teacher reports",
    novemberSeries:
      "November series results are released in mid-January; enquiries about results are finalized in March.",
    juneSeries:
      "June series results are released in mid-August; enquiries about results are finalized in October.",
    downloadIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24"
        viewBox="0 -960 960 960"
        width="24"
        fill="#fff">
        <path d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z" />
      </svg>
    ),
    downloadIconBlue: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24"
        viewBox="0 -960 960 960"
        width="24"
        fill="#0076BD">
        <path d="M480-320 280-520l56-58 104 104v-326h80v326l104-104 56 58-200 200ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z" />
      </svg>
    ),
    uploadIcon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24px"
        viewBox="0 -960 960 960"
        width="24px"
        fill="#fff">
        <path d="M440-320v-326L336-542l-56-58 200-200 200 200-56 58-104-104v326h-80ZM240-160q-33 0-56.5-23.5T160-240v-120h80v120h480v-120h80v120q0 33-23.5 56.5T720-160H240Z" />
      </svg>
    ),
    seriesCalendarYear:
      "You can add data for all series in a given calendar year between March 1 of that year and the last day of February of the following year.",
    overviewLabels: {
      students: "Students",
      exams: "Exams",
      districtPassRate: "District Pass Rate",
      statePassRate: "State Pass Rate",
      nationalPassRate: "National Pass Rate",
    },

    dashboardShortCutLabels: {
      col1: [
        {
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 -960 960 960"
              width="24">
              <path d="m344-60-76-128-144-32 14-148-98-112 98-112-14-148 144-32 76-128 136 58 136-58 76 128 144 32-14 148 98 112-98 112 14 148-144 32-76 128-136-58-136 58Zm34-102 102-44 104 44 56-96 110-26-10-112 74-84-74-86 10-112-110-24-58-96-102 44-104-44-56 96-110 24 10 112-74 86 74 84-10 114 110 24 58 96Zm102-318Zm-42 142 226-226-56-58-170 170-86-84-56 56 142 142Z" />
            </svg>
          ),
          label: "Pass rates",
          path: "/pass-rates",
          tab: 1,
        },
        {
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 -960 960 960"
              width="24">
              <path d="M240-280h240v-80H240v80Zm120-160h240v-80H360v80Zm120-160h240v-80H480v80ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z" />
            </svg>
          ),
          path: "/syllabus-reports",
          label: "Syllabus grades and marks",
          tab: 2,
        },
        {
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 -960 960 960"
              width="24">
              <path d="M320-480v-80h320v80H320Zm0-160v-80h320v80H320Zm-80 240h300q29 0 54 12.5t42 35.5l84 110v-558H240v400Zm0 240h442L573-303q-6-8-14.5-12.5T540-320H240v160Zm480 80H240q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h480q33 0 56.5 23.5T800-800v640q0 33-23.5 56.5T720-80Zm-480-80v-640 640Zm0-160v-80 80Z" />
            </svg>
          ),
          path: "/student-reports",
          label: "Student records",
          tab: 3,
        },
      ],

      col2: [
        // {
        //   path: "/aice-reports",
        //   label: "Cambridge AICE Diploma",
        //   tab: 2,
        //   icon: (
        //     <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 -960 960 960" width="24px"><path d="m392-420.46 33.08-108.62-87-67.07h108.23L480-704.31l33.69 108.16h108.23l-87.61 67.07 33.07 108.62L480-488l-88 67.54ZM260-70.77v-286.31q-38-39.69-59-91.77-21-52.07-21-111.15 0-125.54 87.23-212.77T480-860q125.54 0 212.77 87.23T780-560q0 59.08-21 111.15-21 52.08-59 91.77v286.31l-220-70-220 70ZM480-320q100 0 170-70t70-170q0-100-70-170t-170-70q-100 0-170 70t-70 170q0 100 70 170t170 70ZM320-158.62l160-42.92 160 42.92v-148.61q-34.23 22.31-74.92 34.77Q524.38-260 480-260q-44.38 0-85.08-12.46-40.69-12.46-74.92-34.77v148.61Zm160-74.3Z"/></svg>
        //   ),
        // },
        {
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 -960 960 960"
              width="24">
              <path d="M480-120 200-272v-240L40-600l440-240 440 240v320h-80v-276l-80 44v240L480-120Zm0-332 274-148-274-148-274 148 274 148Zm0 241 200-108v-151L480-360 280-470v151l200 108Zm0-241Zm0 90Zm0 0Z" />
            </svg>
          ),
          path: "/teacher-reports",
          label: "Teacher records",
          tab: 4,
        },
        {
          icon: (
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24"
              viewBox="0 -960 960 960"
              width="24">
              <path d="M40-160v-160q0-34 23.5-57t56.5-23h131q20 0 38 10t29 27q29 39 71.5 61t90.5 22q49 0 91.5-22t70.5-61q13-17 30.5-27t36.5-10h131q34 0 57 23t23 57v160H640v-91q-35 25-75.5 38T480-200q-43 0-84-13.5T320-252v92H40Zm440-160q-38 0-72-17.5T351-386q-17-25-42.5-39.5T253-440q22-37 93-58.5T480-520q63 0 134 21.5t93 58.5q-29 0-55 14.5T609-386q-22 32-56 49t-73 17ZM160-440q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T280-560q0 50-34.5 85T160-440Zm640 0q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T920-560q0 50-34.5 85T800-440ZM480-560q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T600-680q0 50-34.5 85T480-560Z" />
            </svg>
          ),
          path: "/demographics",
          label: "Demographics",
          tab: 5,
        },
      ],
    },
  },
  sideNav: {
    roleNames: [
      "REPORT_MAKER_STATE_STAFF",
      "REPORT_MAKER_DISTRICT_STAFF",
      "REPORT_MAKER_EXAMS_OFFICER",
      "REPORT_MAKER_HEAD_OF_CENTRE",
      "REPORT_MAKER_TEACHER",
      "REPORT_MAKER_CUSTOMER_SUPPORT_ADMIN",
      "ATS_ADMIN",
    ],
    roleKeys: {
      REPORT_MAKER_CUSTOMER_SUPPORT_ADMIN: "support",
      REPORT_MAKER_DISTRICT_STAFF: "district",
      REPORT_MAKER_STATE_STAFF: "state",
      REPORT_MAKER_TEACHER: "teacher",
      REPORT_MAKER_EXAMS_OFFICER: "exams",
      REPORT_MAKER_HEAD_OF_CENTRE: "head",
      ATS_ADMIN: "admin",
    },
    roleBaseApiKeys: {
      csvDownloads: {
        state: "state",
        district: "district",
        exams: "centre",
        head: "centre",
      },
      schoolList: {
        state: "centre",
        district: "centre",
        support: "centre",
      },
      districtList: {
        state: "centre",
        support: "centre",
      },
      passRateReport: {
        state: "state",
        district: "district",
        support: "centre",
        head: "centre",
        exams: "centre",
        stateLevel: {
          state: "district",
          support: "district",
        },
      },
      syllabusReport: {
        support: "centre",
        head: "centre",
        district: "district",
        exams: "centre",
        teacher: "teacher",
      },
      studentReport: {
        state: "centre",
        district: "centre",
        support: "centre",
        head: "centre",
        exams: "centre",
        teacher: "teacher",
      },
      teacherReport: {
        district: "centre",
        support: "centre",
        head: "centre",
        exams: "centre",
      },
      ethinicityReport: {
        state: "centre",
        district: "centre",
        support: "centre",
        head: "centre",
        exams: "centre",
      },
      genderReport: {
        state: "centre",
        district: "centre",
        support: "centre",
        head: "centre",
        exams: "centre",
      },
      gradeDistribution: {
        teacher: "teacher",
        support: "teacher",
      },
      districtOverview: {
        state: "district",
        district: "district",
        support: "district",
      },
      stateOverview: {
        state: "state",
        support: "state",
      },
      districtTotal: {
        state: "state",
        district: "district",
        support: "district",
      },
      stateTotal: {
        state: "state",
        support: "state",
      },
    },
    reportLabels: {
      school: "school reports",
      district: "district reports",
      state: "state reports",
      teacher: "teacher reports",
      exams: "school reports",
      head: "school reports",
      admin: "manage embargo",
      management: {
        exams: "school data management",
        district: "district data management",
        head: "school data management",
      },
    },
    linksOnRoleBase: {
      state: ["Dashboard", "Pass rates", "Demographics"],
      teacher: [
        "Dashboard",
        "Grade Distribution",
        "Syllabus grades and marks",
        "Student records",
      ],
      common: [
        "Dashboard",
        "Pass rates",
        "Syllabus grades and marks",
        "Student records",
        "Teacher records",
        "Demographics",
      ],
      admin: ["Manage results delays"],
    },
    allReportLinks: [
      {
        path: "/dashboard",
        label: "Dashboard",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="16">
            <path d="M200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm200-80v-240H200v240h200Zm80 0h280v-240H480v240ZM200-520h560v-240H200v240Z" />
          </svg>
        ),
      },
      {
        path: "/pass-rates",
        label: "Pass rates",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="16">
            <path d="m344-60-76-128-144-32 14-148-98-112 98-112-14-148 144-32 76-128 136 58 136-58 76 128 144 32-14 148 98 112-98 112 14 148-144 32-76 128-136-58-136 58Zm34-102 102-44 104 44 56-96 110-26-10-112 74-84-74-86 10-112-110-24-58-96-102 44-104-44-56 96-110 24 10 112-74 86 74 84-10 114 110 24 58 96Zm102-318Zm-42 142 226-226-56-58-170 170-86-84-56 56 142 142Z" />
          </svg>
        ),
      },
      {
        path: "/aice-reports",
        label: "Cambridge AICE Diploma",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24px"
            viewBox="0 -960 960 960"
            width="16px"
            fill="#5f6368">
            <path d="m392-420.46 33.08-108.62-87-67.07h108.23L480-704.31l33.69 108.16h108.23l-87.61 67.07 33.07 108.62L480-488l-88 67.54ZM260-70.77v-286.31q-38-39.69-59-91.77-21-52.07-21-111.15 0-125.54 87.23-212.77T480-860q125.54 0 212.77 87.23T780-560q0 59.08-21 111.15-21 52.08-59 91.77v286.31l-220-70-220 70ZM480-320q100 0 170-70t70-170q0-100-70-170t-170-70q-100 0-170 70t-70 170q0 100 70 170t170 70ZM320-158.62l160-42.92 160 42.92v-148.61q-34.23 22.31-74.92 34.77Q524.38-260 480-260q-44.38 0-85.08-12.46-40.69-12.46-74.92-34.77v148.61Zm160-74.3Z" />
          </svg>
        ),
      },
      {
        path: "/syllabus-reports",
        label: "Syllabus grades and marks",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="16">
            <path d="M240-280h240v-80H240v80Zm120-160h240v-80H360v80Zm120-160h240v-80H480v80ZM200-120q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v560q0 33-23.5 56.5T760-120H200Zm0-80h560v-560H200v560Zm0-560v560-560Z" />
          </svg>
        ),
      },
      {
        path: "/student-reports",
        label: "Student records",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="16">
            <path d="M320-480v-80h320v80H320Zm0-160v-80h320v80H320Zm-80 240h300q29 0 54 12.5t42 35.5l84 110v-558H240v400Zm0 240h442L573-303q-6-8-14.5-12.5T540-320H240v160Zm480 80H240q-33 0-56.5-23.5T160-160v-640q0-33 23.5-56.5T240-880h480q33 0 56.5 23.5T800-800v640q0 33-23.5 56.5T720-80Zm-480-80v-640 640Zm0-160v-80 80Z" />
          </svg>
        ),
      },
      {
        path: "/teacher-reports",
        label: "Teacher records",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="16">
            <path d="M480-120 200-272v-240L40-600l440-240 440 240v320h-80v-276l-80 44v240L480-120Zm0-332 274-148-274-148-274 148 274 148Zm0 241 200-108v-151L480-360 280-470v151l200 108Zm0-241Zm0 90Zm0 0Z" />
          </svg>
        ),
      },
      {
        path: "/demographics",
        label: "Demographics",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="16">
            <path d="M40-160v-160q0-34 23.5-57t56.5-23h131q20 0 38 10t29 27q29 39 71.5 61t90.5 22q49 0 91.5-22t70.5-61q13-17 30.5-27t36.5-10h131q34 0 57 23t23 57v160H640v-91q-35 25-75.5 38T480-200q-43 0-84-13.5T320-252v92H40Zm440-160q-38 0-72-17.5T351-386q-17-25-42.5-39.5T253-440q22-37 93-58.5T480-520q63 0 134 21.5t93 58.5q-29 0-55 14.5T609-386q-22 32-56 49t-73 17ZM160-440q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T280-560q0 50-34.5 85T160-440Zm640 0q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T920-560q0 50-34.5 85T800-440ZM480-560q-50 0-85-35t-35-85q0-51 35-85.5t85-34.5q51 0 85.5 34.5T600-680q0 50-34.5 85T480-560Z" />
          </svg>
        ),
      },
      {
        path: "/grade-distribution",
        label: "Grade Distribution",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="16">
            <path d="m344-60-76-128-144-32 14-148-98-112 98-112-14-148 144-32 76-128 136 58 136-58 76 128 144 32-14 148 98 112-98 112 14 148-144 32-76 128-136-58-136 58Zm34-102 102-44 104 44 56-96 110-26-10-112 74-84-74-86 10-112-110-24-58-96-102 44-104-44-56 96-110 24 10 112-74 86 74 84-10 114 110 24 58 96Zm102-318Zm-42 142 226-226-56-58-170 170-86-84-56 56 142 142Z" />
          </svg>
        ),
      },
      {
        path: "/manage-results-delays",
        label: "Manage results delays",
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 0 24 24"
            width="16">
            <path d="M19.14,12.94c0.04-0.31,0.06-0.63,0.06-0.94s-0.02-0.63-0.06-0.94l2.03-1.58c0.18-0.14,0.23-0.4,0.12-0.61l-1.92-3.32c-0.11-0.21-0.36-0.3-0.58-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.5,2.5c-0.03-0.23-0.23-0.4-0.47-0.4h-4.06c-0.24,0-0.44,0.17-0.47,0.4L9.14,5.31C8.55,5.55,8.02,5.87,7.52,6.25L5.14,5.29c-0.22-0.09-0.47,0.01-0.58,0.22L2.64,8.83c-0.11,0.21-0.06,0.47,0.12,0.61L4.79,11.02c-0.04,0.31-0.06,0.63-0.06,0.94s0.02,0.63,0.06,0.94l-2.03,1.58c-0.18,0.14-0.23,0.4-0.12,0.61l1.92,3.32c0.11,0.21,0.36,0.3,0.58,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.81c0.03,0.23,0.23,0.4,0.47,0.4h4.06c0.24,0,0.44-0.17,0.47-0.4l0.36-2.81c0.59-0.24,1.12-0.56,1.62-0.94l2.39,0.96c0.22,0.09,0.47-0.01,0.58-0.22l1.92-3.32c0.11-0.21,0.06-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.99,0-3.6-1.61-3.6-3.6s1.61-3.6,3.6-3.6s3.6,1.61,3.6,3.6S13.99,15.6,12,15.6z" />
          </svg>
        ),
      },
    ],
    allManagementLinks: [
      {
        path: "/student-data",
        label: "Add student data",
        tab: 0,
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="16">
            <path d="M720-240q25 0 42.5-17.5T780-300q0-25-17.5-42.5T720-360q-25 0-42.5 17.5T660-300q0 25 17.5 42.5T720-240Zm0 120q30 0 56-14t43-39q-23-14-48-20.5t-51-6.5q-26 0-51 6.5T621-173q17 25 43 39t56 14Zm-520 0q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v268q-19-9-39-15.5t-41-9.5v-243H200v560h242q3 22 9.5 42t15.5 38H200Zm0-120v40-560 243-3 280Zm80-40h163q3-21 9.5-41t14.5-39H280v80Zm0-160h244q32-30 71.5-50t84.5-27v-3H280v80Zm0-160h400v-80H280v80ZM720-40q-83 0-141.5-58.5T520-240q0-83 58.5-141.5T720-440q83 0 141.5 58.5T920-240q0 83-58.5 141.5T720-40Z" />
          </svg>
        ),
      },
      {
        path: "/teacher-data",
        label: "Add teacher rosters",
        tab: 1,
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="16">
            <path d="M680-320q-50 0-85-35t-35-85q0-50 35-85t85-35q50 0 85 35t35 85q0 50-35 85t-85 35Zm0-80q17 0 28.5-11.5T720-440q0-17-11.5-28.5T680-480q-17 0-28.5 11.5T640-440q0 17 11.5 28.5T680-400ZM440-40v-116q0-21 10-39.5t28-29.5q32-19 67.5-31.5T618-275l62 75 62-75q37 6 72 18.5t67 31.5q18 11 28.5 29.5T920-156v116H440Zm79-80h123l-54-66q-18 5-35 13t-34 17v36Zm199 0h122v-36q-16-10-33-17.5T772-186l-54 66Zm-76 0Zm76 0Zm-518 0q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v200q-16-20-35-38t-45-24v-138H200v560h166q-3 11-4.5 22t-1.5 22v36H200Zm80-480h280q26-20 57-30t63-10v-40H280v80Zm0 160h200q0-21 4.5-41t12.5-39H280v80Zm0 160h138q11-9 23.5-16t25.5-13v-51H280v80Zm-80 80v-560 137-17 440Zm480-240Z" />
          </svg>
        ),
      },
      {
        path: "/district-data",
        label: "Upload district data",
        tab: 2,
        icon: (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            height="24"
            viewBox="0 -960 960 960"
            width="16">
            <path d="M720-240q25 0 42.5-17.5T780-300q0-25-17.5-42.5T720-360q-25 0-42.5 17.5T660-300q0 25 17.5 42.5T720-240Zm0 120q30 0 56-14t43-39q-23-14-48-20.5t-51-6.5q-26 0-51 6.5T621-173q17 25 43 39t56 14Zm-520 0q-33 0-56.5-23.5T120-200v-560q0-33 23.5-56.5T200-840h560q33 0 56.5 23.5T840-760v268q-19-9-39-15.5t-41-9.5v-243H200v560h242q3 22 9.5 42t15.5 38H200Zm0-120v40-560 243-3 280Zm80-40h163q3-21 9.5-41t14.5-39H280v80Zm0-160h244q32-30 71.5-50t84.5-27v-3H280v80Zm0-160h400v-80H280v80ZM720-40q-83 0-141.5-58.5T520-240q0-83 58.5-141.5T720-440q83 0 141.5 58.5T920-240q0 83-58.5 141.5T720-40Z" />
          </svg>
        ),
      },
    ],
  },
  routes: [
    { path: "*", component: <Navigate to="/" /> },
    {
      path: "/",
      component: (
        <Suspense fallback="Loading">
          <Newuser />{" "}
        </Suspense>
      ),
    },
    {
      path: "dashboard",
      component: (
        <Suspense fallback="Loading">
          <Dashboard />
        </Suspense>
      ),
    },
    {
      path: "pass-rates",
      component: (
        <Suspense fallback="Loading">
          <PassRate />
        </Suspense>
      ),
    },
    {
      path: "aice-reports",
      component: (
        <Suspense fallback="Loading">
          <AiceReports />
        </Suspense>
      ),
    },
    {
      path: "syllabus-reports",
      component: (
        <Suspense fallback="Loading">
          {" "}
          <SyllabusReports />{" "}
        </Suspense>
      ),
    },
    {
      path: "student-reports",
      component: (
        <Suspense fallback="Loading">
          {" "}
          <StudentReports />
        </Suspense>
      ),
    },
    {
      path: "teacher-reports",
      component: (
        <Suspense fallback="Loading">
          {" "}
          <TeacherReports />
        </Suspense>
      ),
    },
    {
      path: "demographics",
      component: (
        <Suspense fallback="Loading">
          <Demographics />{" "}
        </Suspense>
      ),
    },
    {
      path: "student-details",
      component: (
        <Suspense fallback="Loading">
          <StudentDetail />{" "}
        </Suspense>
      ),
    },
    {
      path: "grade-distribution",
      component: (
        <Suspense fallback="Loading">
          <GradeDistribution />
        </Suspense>
      ),
    },
    {
      path: "support-admin",
      component: (
        <Suspense fallback="Loading">
          <SupportAdmin />
        </Suspense>
      ),
    },
    { path: "student-data", component: <StudentData /> },
    { path: "teacher-data", component: <TeacherData /> },
    { path: "district-data", component: <DistrictData /> },
    {
      path: "manage-results-delays",
      component: (
        <Suspense fallback="Loading">
          <ManageResultsDelay />{" "}
        </Suspense>
      ),
    },
  ],

  syllabusCompDefaultSubHeaders: [
    {
      col: "candNumber",
      label: "Students",
      id: "stuId",
      sortVisible: true,
      sortOrder: "asc",
      class: "col_width",
      colSpan: "",
    },
    {
      col: "finalTotal",
      label: "Total",
      id: "finTotal",
      sortVisible: false,
      sortOrder: "asc",
      class: "fg_bg_color w-5 text-center tot_col_width",
      colSpan: "1",
    },
    {
      col: "finalGrade",
      label: "Grade",
      id: "finGrade",
      sortVisible: false,
      sortOrder: "asc",
      class: "fg_bg_color w-5 text-center tot_col_width",
      colSpan: "1",
    },
  ],

  syllabusCompDynamicSubHeaders: [
    {
      col: "max",
      label: "Max",
      id: "maxScore",
      sortVisible: false,
      sortOrder: "asc",
    },
    {
      col: "mark",
      label: "Mark",
      id: "markScore",
      sortVisible: false,
      sortOrder: "asc",
    },
    {
      col: "grade",
      label: "Grade",
      id: "gradeScore",
      sortVisible: false,
      sortOrder: "asc",
    },
  ],

  teacherSyllabusCompDefaultSubHeaders: [
    {
      col: "candNumber",
      label: "Students",
      id: "stuId",
      sortVisible: true,
      sortOrder: "asc",
      class: "col_width",
      colSpan: "",
    },
    {
      col: "finalTotal",
      label: "Total",
      id: "finTotal",
      sortVisible: false,
      sortOrder: "asc",
      class: "fg_bg_color text-center w-5 tot_col_width",
      colSpan: "1",
    },
    {
      col: "finalGrade",
      label: "Grade",
      id: "finGrade",
      sortVisible: false,
      sortOrder: "asc",
      class: "fg_bg_color text-center w-5 tot_col_width",
      colSpan: "1",
    },
  ],

  teacherSyllabusCompDynamicSubHeaders: [
    {
      col: "max",
      label: "Max",
      id: "maxScore",
      sortVisible: false,
      sortOrder: "asc",
    },
    {
      col: "mark",
      label: "Mark",
      id: "markScore",
      sortVisible: false,
      sortOrder: "asc",
    },
    {
      col: "grade",
      label: "Grade",
      id: "gradeScore",
      sortVisible: false,
      sortOrder: "asc",
    },
  ],

  gradeDistributionStaticHeaders: {
    "A Level": {
      sylCode: {
        col: "sylId",
        id: "sylCode",
        sortVisible: false,
        sortOrder: "asc",
        class: "w-5 text-center",
      },
      totCount: {
        col: "examsCount",
        id: "totCount",
        sortVisible: false,
        sortOrder: "asc",
        class: "w-5 text-center",
      },
      pRateC: {
        col: "colC",
        id: "pRateC",
        sortVisible: false,
        sortOrder: "asc",
        class: "w-5 text-center head_bg_yellow",
      },
      schoolGte: {
        col: "colE",
        id: "schoolGte",
        sortVisible: false,
        sortOrder: "asc",
        class: "w-5 text-center head_bg_blue",
      },
    },
    "AS Level": {
      sylCode: {
        col: "sylId",
        id: "sylCode",
        sortVisible: false,
        sortOrder: "asc",
        class: "w-5 text-center",
      },
      totCount: {
        col: "examsCount",
        id: "totCount",
        sortVisible: false,
        sortOrder: "asc",
        class: "w-5 text-center",
      },
      pRateC: {
        col: "colC",
        id: "pRateC",
        sortVisible: false,
        sortOrder: "asc",
        class: "w-5 text-center head_bg_yellow",
      },
      schoolGte: {
        col: "colE",
        id: "schoolGte",
        sortVisible: false,
        sortOrder: "asc",
        class: "w-5 text-center head_bg_blue",
      },
    },
    IGCSE: {
      sylCode: {
        col: "sylId",
        id: "sylCode",
        sortVisible: false,
        sortOrder: "asc",
        class: "w-5 text-center",
      },
      totCount: {
        col: "examsCount",
        id: "totCount",
        sortVisible: false,
        sortOrder: "asc",
        class: "w-5 text-center",
      },
      pRateC: {
        col: "colC",
        id: "pRateC",
        sortVisible: false,
        sortOrder: "asc",
        class: "w-5 text-center head_bg_yellow",
      },
      schoolGte: {
        col: "colE",
        id: "schoolGte",
        sortVisible: false,
        sortOrder: "asc",
        class: "w-5 text-center head_bg_blue",
      },
    },
  },

  syllabusReportAlert:
    "Your Exams Officer must provide teacher roster information before you can view this report.",

  dropDownList: {
    qualification: [
      {
        value: "A Level",
        label: "A Level",
      },
      {
        value: "AS Level",
        label: "AS Level",
      },
      {
        value: "IGCSE",
        label: "IGCSE",
      },
    ],
    qualsBySyllabus: [
      {
        value: "AS and A Level",
        label: "AS & A Level",
      },
      {
        value: "IGCSE",
        label: "IGCSE",
      },
    ],
  },
  demographics: {
    header: "DEMOGRAPHICS",
    subHeader:
      "View pass rates by ethnicity/race or gender.  AS & A Level grades are awarded on a scale from A* (A Level) or A (AS Level) to E. IGCSE grades are awarded on a scale from A* to G",
    stateSubHeader: "Detailed reports for demographics within your state",
    genderHeaders: [
      {
        col: "gender",
        label: "Gender",
        id: "gender_name",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        col: "passrate",
        label: "Pass rate",
        id: "gte_progress_gender",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        col: "totalCount",
        label: "Students",
        id: "exams",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        col: "passrate",
        label: "%",
        id: "gender_passrate",
        sortVisible: true,
        sortOrder: "asc",
      },
    ],
    ethinicHeaders: [
      {
        col: "ethnicityLabel",
        label: "Ethnicity / race",
        id: "ethinic_name",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        col: "passrate",
        label: "Pass rate",
        id: "gte_progress_ethinic",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        col: "totalCount",
        label: "Exams",
        id: "ethinic_exams",
        sortVisible: false,
        sortOrder: "asc",
      },
      {
        col: "passrate",
        label: "gte",
        id: "ethinic_passrate",
        sortVisible: true,
        sortOrder: "asc",
      },
    ],
    ethnicityCodes: {
      AI: "American Indian or Alaska Native",
      AS: "Asian",
      BL: "Black or African American",
      PI: "Native Hawaiian or Pacific Islander",
      WH: "White",
      LA: "Hispanic, Latino, or Spanish",
      TW: "Two or More Races",
      UN: "Unknown or Not Reported",
    },
    common: `<strong>Student demographic data</strong> is missing. We can not provide detailed demographic reports on Ethinicity, Race, Social Economic Status for your school.
    <a href="https://www.cambridge.org/" target="_blank"><strong> Find out more</strong></a>`,
    district: `<strong>Student demographic data</strong> is missing. We can not provide detailed demographic reports for your school.
    <a href="https://www.cambridge.org/" target="_blank"><strong> Find out more</strong></a>`,
  },

  aiceReports: {
    head1: "AICE REPORTS",
    subHead1: "AICE grades for those students who completed in ",
    head2: "Cambridge AICE Diploma",
    subHead2: "Get information on",
    subHead3: "Cambridge AICE Diploma grades.",
    subHead4: "View selectedYear AICE Diploma students.",
    aiceDiplomaLink:
      "https://www.cambridgeinternational.org/programmes-and-qualifications/cambridge-advanced/cambridge-aice-diploma/qualification/",
    tableHeaders: [
      { label: "Number", class: "candId" },
      { label: "Student name", class: "name" },
      { label: "Grade", class: "grade" },
    ],
    grades: {
      m: "Merit",
      d: "Distinction",
      p: "Pass",
      f: "Fail",
    },
  },

  noAccess: {
    icon1: (
      <svg
        width="57"
        height="46"
        viewBox="0 0 57 46"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M5.83337 0.333374H51.1667C54.2834 0.333374 56.805 2.88337 56.805 6.00004L56.8334 40C56.8334 43.1167 54.2834 45.6667 51.1667 45.6667H5.83337C2.7167 45.6667 0.166704 43.1167 0.166704 40V6.00004C0.166704 2.88337 2.7167 0.333374 5.83337 0.333374ZM51.1667 14.5H21.4167V24.4167H51.1667V14.5ZM51.1667 30.0834H21.4167V40H48.3334C49.8917 40 51.1667 38.725 51.1667 37.1667V30.0834ZM8.6667 40H15.75V14.5H5.83337V37.1667C5.83337 38.725 7.10837 40 8.6667 40Z"
          fill="#9E9E9E"></path>
      </svg>
    ),
    icon2: (
      <svg
        style={{ left: "calc(50% + 3px)", position: "absolute" }}
        width="31"
        height="32"
        viewBox="0 0 31 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg">
        <path
          d="M15.5 1C7.22 1 0.5 7.72 0.5 16C0.5 24.28 7.22 31 15.5 31C23.78 31 30.5 24.28 30.5 16C30.5 7.72 23.78 1 15.5 1ZM15.5 28C8.87 28 3.5 22.63 3.5 16C3.5 13.225 4.445 10.675 6.035 8.65L22.85 25.465C20.825 27.055 18.275 28 15.5 28ZM24.965 23.35L8.15 6.535C10.175 4.945 12.725 4 15.5 4C22.13 4 27.5 9.37 27.5 16C27.5 18.775 26.555 21.325 24.965 23.35Z"
          fill="#0076BD"
          stroke="#0076BD"></path>
      </svg>
    ),
    mainText: "You do not have access",
    subText1:
      "Please contact your School admin or Centre Exam Officer to get access.",
    subText2: "You can also contact Cambridge International at",
    mail: "info@cambridgeinternational.org",
  },

  dataManagement: {
    student: "student",
    studentDesc1:
      "Enhance your reports: Add student data for June seriesyear and November seriesyear series including demographics, state ID, and graduation year.",
    studentDesc2:
      "You can add data for all series in a given calendar year between March 1 of that year and the last day of February of the following year. For example, you can add data for June seriesyear and November seriesyear series any time between March 1, seriesyear and February 28, yearplusone.",
    stuStepOneSubHead:
      "This Excel file contains data we hold for students entered for exams in June and/or the following November series.",
    stuStepTwoHead: "Add student data to your file ",
    teachStepTwoHead: "Add teacher email addresses",
    stuStepTwoSubHead:
      "In the columns provided, add student state ID, graduation year, and ethnicity/race.",
    guidanceDoc: "View data guidance (.pdf)",
    stuStepThreeHead: "Upload your file",
    stuStepThreeSubHead:
      "We will auto-validate the file to detect formatting errors. ",
    teachStepThreeHead: "Upload rosters file",
    teachStepThreeSubHead:
      "We will auto-validate your file to detect formatting errors.",
    roster: "roster",
    teachRoster: "rosters",
    teacher: "teacher",
    teachDesc1:
      "Enhance your reports: Add teacher class rosters for June seriesyear and November seriesyear series to view and share class results.",
    teachDesc2:
      "You can add data for all series in a given calendar year between March 1 of that year and the last day of February of the following year. For example, you can add data for June seriesyear and November seriesyear series any time between March 1, seriesyear and February 28, yearplusone.",
    teaStepOneSubHead:
      "This Excel file contains students entered for exams in June and/or the following November series.",
    teaStepTwoSubHead:
      "In the column provided, add the email address of each student’s teacher by syllabus. (This will not give teachers access. See ‘Account management’ for granting access.)",
    dataGuidance:
      "https://www.cambridgeinternational.org/Images/711962-cambridge-report-maker-data-guide.pdf",
  },

  alertMsgs: {
    technical: "Facing techincal issue while retrieveing data",
    unauthorized: "You are not authorized to access this page",
    noDetail: "No details found",
    noHistory: "No history found",
  },

  supportAdmin: {
    lbl: "emulate a user",
    sub_lbl: "Log in as a specific user and see what they see",
    dropDowns: [
      {
        header: "State official",
        selectLabel: "Select state",
        btnLabel: "Emulate state official",
        userSelectedDropDown: "stateSelectedValue",
        selectedId: "stateCode",
        dataList: [],
        strMix: false,
        option: "stateCode",
        value: "centreState",
      },
      {
        header: "District administrator",
        selectLabel: "Select district",
        btnLabel: "Emulate district administrator",
        userSelectedDropDown: "districtSelectedValue",
        selectedId: "districtID",
        dataList: [],
        strMix: false,
        option: "districtID",
        value: "districtName",
      },
      {
        header: "Exams officer",
        selectLabel: "Select school",
        btnLabel: "Emulate exams officer",
        userSelectedDropDown: "schoolSelectedValue",
        selectedId: "centreID",
        dataList: [],
        strMix: true,
        option: "centreID",
        value: "centreName",
      },
    ],
  },
  switchCentreLogo: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="24px"
      viewBox="0 -960 960 960"
      width="24px"
      fill="#fff">
      <path d="M80-120v-720h400v160h400v560H80Zm80-80h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 480h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm0-160h80v-80h-80v80Zm160 480h320v-400H480v80h80v80h-80v80h80v80h-80v80Zm160-240v-80h80v80h-80Zm0 160v-80h80v80h-80Z" />
    </svg>
  ),

  switchCentreText: "Select another centre",

  deviceRegEx: /android|iphone|kindle|ipad/i,

  noNetwork: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      height="200px"
      viewBox="0 -960 960 960"
      width="200px"
      fill="#5f6368">
      <path d="M790-56 414-434q-47 11-87.5 33T254-346l-84-86q32-32 69-56t79-42l-90-90q-41 21-76.5 46.5T84-516L0-602q32-32 66.5-57.5T140-708l-84-84 56-56 736 736-58 56Zm-310-64q-42 0-71-29.5T380-220q0-42 29-71t71-29q42 0 71 29t29 71q0 41-29 70.5T480-120Zm236-238-29-29-29-29-144-144q81 8 151.5 41T790-432l-74 74Zm160-158q-77-77-178.5-120.5T480-680q-21 0-40.5 1.5T400-674L298-776q44-12 89.5-18t92.5-6q142 0 265 53t215 145l-84 86Z" />
    </svg>
  ),

  product_logo: (
    <svg xmlns="http://www.w3.org/2000/svg" width="190" height="32" fill="none">
      <g clip-path="url(#a)">
        <path
          fill="#0E0E0E"
          d="m142.424 4.213.036 2.819s-.342.086-.45.116c-.101-1.233-.38-2.24-2.352-2.24h-2.649v5.212h2.273c1.116 0 1.419-.623 1.545-1.7h.452v4.358l-.451.007c-.07-1.042-.315-1.851-1.537-1.851h-2.283v4.576c0 1.33 1.145 1.33 2.359 1.33 2.177 0 3.187-.136 3.795-2.34.089.023.447.1.447.1l-.61 2.938h-9.891v-.488h.188c.759 0 1.46-.141 1.46-1.177V5.877c0-1.034-.701-1.178-1.46-1.178h-.188v-.486h9.315m-53.904 0h-5.966v.486h.263c.491 0 1.405 0 1.405 1.544v9.689c0 .825-.757 1.118-1.405 1.118h-.263v.488h5.792v-.488h-.264c-.944 0-1.61-.116-1.61-1.62v-4.15h1.471l3.965 6.258h3.41v-.498c-.898-.05-1.325-.361-1.849-1.168L90.2 10.896l.086-.036c1.166-.472 2.646-1.432 2.646-3.327 0-2.234-1.465-3.321-4.415-3.321m-.755.543c1.705 0 2.837 1.138 2.837 2.895 0 2.166-.915 3.09-2.989 3.09h-1.138v-5.9c.379-.061.89-.085 1.29-.085Zm13.936-.544h-5.566v.487h.188c.76 0 1.46.144 1.46 1.177v9.998c0 1.035-.7 1.177-1.46 1.177h-.188v.488h5.566v-.488h-.188c-.759 0-1.46-.142-1.46-1.177V5.875c0-1.033.701-1.177 1.46-1.177h.188v-.487Zm-76.235 6.653c0 4.49 2.74 7.027 7.039 7.027 2.114 0 3.97-.828 5.173-2.383l-.349-.652c-1.067 1.372-2.481 2.115-4.465 2.115-3.529 0-4.986-3.112-4.986-6.404 0-3.698 1.802-5.995 4.702-5.995s3.659 1.638 4.162 3.426l.438-.056-.141-3.085c-1.39-.648-2.81-.957-4.514-.957-1.902 0-3.587.646-4.871 1.796-1.384 1.24-2.187 3.186-2.187 5.168m28.735-4.075s4.772 10.732 4.818 10.841h.402l4.608-11.058.406 8.52.02.956c0 .904-.651.942-1.552.997 0 0-.021 0-.036.002v.48h5.53v-.48c-1.02-.038-1.563-.132-1.642-1.166l-.515-8.839c-.113-1.883.152-2.35 1.651-2.35h.072v-.49h-3.698l-4.282 10.1s-4.48-9.993-4.525-10.1h-3.772v.485h.155c1.059 0 1.689.653 1.62 1.802l-.52 8.425c-.07 1.23-.163 2.072-1.678 2.132h-.172v.483h4.493v-.483h-.114c-1.225-.046-1.79-.206-1.71-2.029l.442-8.23m55.855 10.746c1.847 0 3.673-.442 4.977-1.733 1.295-1.286 2.038-3.094 2.038-4.962 0-1.999-.676-3.681-1.952-4.87-1.296-1.207-3.151-1.762-5.365-1.762l-5.958.005v.487h.189c.758 0 1.461.143 1.461 1.177v9.996c0 1.036-.702 1.177-1.461 1.177h-.189v.489l6.259-.004h.001Zm-.99-12.75c3.748 0 5.57 2.011 5.57 6.427 0 2.842-1.532 5.74-4.899 5.74-1.429 0-2.027-.227-2.027-1.641V4.845c.32-.034 1.025-.062 1.356-.062Zm19.348 12.068c-.5.226-1.343.351-2.158.334-3.538 0-5.122-3.345-5.122-6.72 0-3.674 1.877-5.956 4.972-5.956 2.295 0 3.317.899 3.869 3.19l.447-.029-.213-3.18c-1.029-.345-2.654-.66-4.235-.66-3.527 0-7.278 2.139-7.278 6.831 0 4.412 2.844 7.264 7.242 7.264 1.822 0 3.462-.311 4.685-.704l.002-3.637c0-.714.379-1.092 1.095-1.092h.155v-.476h-5.122v.476h.155c.985 0 1.504.378 1.504 1.092v3.268m-52.929-6.216c2.088 0 3.334 1.162 3.334 3.208 0 1.82-1.225 3.156-2.848 3.156-1.352 0-1.766-.373-1.766-1.675v-4.69h1.28Zm-.074-5.934c1.754 0 2.644.875 2.644 2.757 0 1.703-1.012 2.593-2.847 2.593h-1.002V4.7h1.206v.002Zm1.526 5.58c1.635-.265 3.492-1.046 3.492-3.157 0-1.906-1.53-2.913-4.308-2.913l-5.915.003v.488h.263c.49 0 1.403 0 1.403 1.543v9.669c0 .827-.757 1.135-1.403 1.135h-.263v.483h6.528c2.492 0 4.41-1.675 4.41-3.767 0-.876-.307-1.63-.887-2.223-.751-.769-1.643-1.138-3.32-1.26M44.588 4.21l4.34 11.561c.322.914.793 1.275 1.48 1.275h.04v.492h-5.16v-.492h.116c1.003 0 1.397-.42 1.095-1.345l-1.05-2.929h-4.2l-.967 2.687c-.425 1.26.24 1.573 1.215 1.573h.176v.5H37.62l.002-.5h.046c.82 0 1.374-.505 1.688-1.322l4.23-11.502 1.003.002Zm-3.1 7.908h3.727l-1.862-5.192-1.867 5.192h.001Z"
        />
        <path
          stroke="#FFD102"
          stroke-miterlimit="10"
          stroke-width=".16"
          d="M19.96 13.257c-.044 1.094-.204 2.085-.478 2.954a7.312 7.312 0 0 1-1.124 2.228c-.898 1.186-1.989 1.78-2.711 2.172-.063.035-.491.252-2.551 1.279v-8.634h6.864M7.831 13.257v8.634a234.87 234.87 0 0 1-2.55-1.279c-.723-.392-1.814-.986-2.712-2.172a7.29 7.29 0 0 1-1.125-2.228c-.273-.868-.433-1.861-.477-2.954H7.83"
        />
        <path
          stroke="#171614"
          stroke-miterlimit="10"
          stroke-width=".16"
          d="M19.973.955h-6.877v7.04h6.877V.954ZM7.832.955H.955v7.04h6.878V.954h-.001Z"
        />
        <path
          fill="#1D1D1B"
          d="M0 0v12.622c0 6.205 3.26 7.977 4.826 8.829.287.156 5.12 2.559 5.43 2.712l.208.11.208-.11c.28-.14 5.143-2.556 5.43-2.712 1.567-.852 4.826-2.623 4.826-8.83V0H0Z"
        />
        <path
          fill="#fff"
          d="M12.594 8.496V.452H8.336v8.044H.453V12.755h7.882v9.948l2.128 1.059s.993-.493 2.13-1.06v-9.947h7.88l.002-.132V8.496h-7.883.002Z"
        />
        <path
          fill="#E63337"
          d="M8.336.452H.453v8.044h7.883V.452ZM20.476.452h-7.882v8.044h7.882V.452ZM8.337 12.755H.455c.045 5.766 3.002 7.436 4.588 8.3.16.087 1.844.927 3.294 1.649v-9.949ZM12.594 12.755v9.948c1.449-.722 3.132-1.562 3.294-1.65 1.585-.862 4.543-2.533 4.587-8.3h-7.881v.002Z"
        />
        <path
          fill="#1D1D1B"
          d="m15.301 10.688.163-.193-.206-.244-.205.244.163.193c.002.097.008.95-.495 1.255 0 0 .167.032.392-.011 0 0 .039.222.144.475.106-.254.145-.475.145-.475.225.043.392.01.392.01-.503-.304-.497-1.157-.494-1.254h.001ZM16.584 9.238l.163-.193-.206-.244-.205.244.163.193c.002.098.008.95-.495 1.256 0 0 .168.032.392-.012 0 0 .039.223.145.476.105-.254.144-.476.144-.476.226.044.392.012.392.012-.503-.305-.497-1.158-.494-1.256h.001ZM17.87 10.688l.162-.193-.205-.244-.206.244.163.193c.002.097.008.95-.495 1.255 0 0 .168.032.392-.011 0 0 .039.222.145.475.105-.254.144-.475.144-.475.226.043.392.01.392.01-.503-.304-.497-1.157-.494-1.254h.001ZM19.153 9.238l.162-.193-.205-.244-.205.244.162.193c.002.098.008.95-.495 1.256 0 0 .168.032.393-.012 0 0 .038.223.144.476.106-.254.144-.476.144-.476.225.044.392.012.392.012-.503-.305-.497-1.158-.493-1.256ZM14.018 9.238l.162-.193-.205-.244-.205.244.162.193c.002.098.009.95-.495 1.256 0 0 .168.032.393-.012 0 0 .038.223.144.476a2.5 2.5 0 0 0 .144-.476c.225.044.393.012.393.012-.503-.305-.497-1.158-.495-1.256h.002ZM3.145 10.688l.162-.193-.205-.244-.205.244.162.193c.002.097.009.95-.495 1.255 0 0 .168.032.393-.011 0 0 .038.222.144.475.106-.254.144-.475.144-.475.225.043.393.01.393.01-.503-.304-.497-1.157-.494-1.254ZM4.428 9.238l.163-.193-.206-.244-.205.244.163.193c.002.098.008.95-.495 1.256 0 0 .167.032.393-.012 0 0 .039.223.144.476a2.5 2.5 0 0 0 .145-.476c.224.044.392.012.392.012-.503-.305-.497-1.158-.494-1.256ZM5.713 10.688l.163-.193-.206-.244-.205.244.163.193c.002.097.008.95-.495 1.255 0 0 .168.032.392-.011 0 0 .039.222.144.475.106-.254.145-.475.145-.475.224.043.392.01.392.01-.503-.304-.497-1.157-.494-1.254h.001ZM6.996 9.238l.163-.193-.205-.244-.206.244.163.193c.002.098.008.95-.495 1.256 0 0 .168.032.392-.012 0 0 .04.223.145.476a2.5 2.5 0 0 0 .144-.476c.225.044.392.012.392.012-.503-.305-.497-1.158-.494-1.256h.001ZM1.862 9.238l.162-.193-.205-.244-.205.244.162.193c.002.098.008.95-.495 1.256 0 0 .168.032.393-.012 0 0 .038.223.144.476a2.5 2.5 0 0 0 .144-.476c.226.044.392.012.392.012-.503-.305-.496-1.158-.493-1.256ZM10.516 13.955l.162-.193-.205-.244-.205.244.162.193c.002.098.009.95-.494 1.255 0 0 .167.033.392-.01 0 0 .039.222.144.476.106-.254.145-.477.145-.477.225.044.393.011.393.011-.503-.305-.497-1.157-.495-1.255ZM10.516 18.313l.162-.193-.205-.244-.205.244.162.193c.002.098.009.95-.494 1.255 0 0 .167.033.392-.01 0 0 .039.222.144.475.106-.254.145-.476.145-.476.225.044.393.011.393.011-.503-.305-.497-1.157-.495-1.255ZM11.705 16.134l.163-.193-.205-.244-.206.244.163.193c.002.098.01.95-.495 1.255 0 0 .168.033.393-.01 0 0 .039.222.145.476.105-.254.144-.477.144-.477.225.044.392.011.392.011-.503-.305-.497-1.157-.495-1.255h.001ZM9.313 16.134l.162-.193-.205-.244-.205.244.162.193c.002.098.01.95-.495 1.255 0 0 .168.033.393-.01 0 0 .038.222.144.476.106-.254.144-.477.144-.477.226.044.393.011.393.011-.503-.305-.497-1.157-.495-1.255h.002ZM11.705 20.492l.163-.193-.205-.244-.206.244.163.193c.002.098.01.95-.495 1.255 0 0 .168.033.393-.01 0 0 .039.222.145.476.105-.254.144-.477.144-.477.225.044.392.011.392.011-.503-.305-.497-1.157-.495-1.255h.001ZM9.313 20.492l.162-.193-.205-.244-.205.244.162.193c.002.098.01.95-.495 1.255 0 0 .168.033.393-.01 0 0 .038.222.144.476.106-.254.144-.477.144-.477.226.044.393.011.393.011-.503-.305-.497-1.157-.495-1.255h.002ZM10.516 4.029l.162-.193-.205-.244-.205.244.162.193c.002.097.009.95-.494 1.255 0 0 .167.032.392-.011 0 0 .039.222.144.475.106-.254.145-.475.145-.475.225.043.393.01.393.01-.503-.304-.497-1.157-.495-1.254ZM11.705 1.85l.163-.193-.205-.244-.206.244.163.193c.002.097.01.95-.495 1.255 0 0 .168.032.393-.011 0 0 .039.222.145.475.105-.254.144-.475.144-.475.225.043.392.01.392.01-.503-.304-.497-1.157-.495-1.254h.001ZM9.313 1.85l.162-.193-.205-.244-.205.244.162.193c.002.097.01.95-.495 1.255 0 0 .168.032.393-.011 0 0 .038.222.144.475.106-.254.144-.475.144-.475.226.043.393.01.393.01-.503-.304-.497-1.157-.495-1.254h.002ZM11.705 6.208l.163-.193-.205-.244-.206.244.163.193c.002.097.01.95-.495 1.255 0 0 .168.032.393-.011 0 0 .039.222.145.475.105-.254.144-.475.144-.475.225.043.392.01.392.01-.503-.304-.497-1.157-.495-1.254h.001ZM9.313 6.208l.162-.193-.205-.244-.205.244.162.193c.002.097.01.95-.495 1.255 0 0 .168.032.393-.011 0 0 .038.222.144.475.106-.254.144-.475.144-.475.226.043.393.01.393.01-.503-.304-.497-1.157-.495-1.254h.002ZM6.633 4.424l.026.1c.024.091.042.162.054.214.084.382.154.482.34.482.106 0 .194-.06.22-.148l.041-.134a.064.064 0 0 1 .064-.048c.073 0 .106.075.11.242 0 .048.017.158.047.328.017.1.026.198.026.291a.47.47 0 0 1-.04.21c.023.13.041.308.041.41 0 .165-.031.318-.08.399.028.11.034.155.034.252 0 .07-.007.15-.02.222a1.62 1.62 0 0 0-.036.231c0 .03.006.06.015.09.013.038.02.065.02.08 0 .02-.009.033-.02.033l-.133-.054-.147-.08a.716.716 0 0 1-.154-.12c-.13.117-.169.134-.508.228a.476.476 0 0 0-.147.06c-.042.03-.074.046-.089.046-.057 0-.085-.093-.085-.284 0-.141.014-.273.04-.372a.753.753 0 0 0-.238-.06c-.01 0-.045.005-.102.013l-.025.002c-.02 0-.036-.03-.036-.064 0-.026.018-.09.04-.145l.067-.16a.562.562 0 0 1 .16-.194.415.415 0 0 1 .174-.1l.24-.046c.144-.027.229-.104.229-.203 0-.1-.064-.16-.209-.212l-.287-.1a1.54 1.54 0 0 1-.262-.127c-.16-.095-.186-.107-.224-.107-.057 0-.09.044-.09.119 0 .119.077.202.186.202a.192.192 0 0 0 .067-.013.228.228 0 0 1 .07-.02c.03 0 .046.017.046.05l-.002.03-.013.114c-.011.097-.074.214-.213.401l-.06.08a.918.918 0 0 1-.361.528.862.862 0 0 0-.074.053.888.888 0 0 0-.054.093 1.1 1.1 0 0 1-.133.16 1.26 1.26 0 0 1-.167.154.617.617 0 0 0-.133.121l-.067.114a.065.065 0 0 1-.054.034c-.059 0-.114-.061-.147-.167-.025-.078-.047-.1-.097-.1a.527.527 0 0 0-.117.02l-.093.013h-.241c-.12 0-.29.031-.367.067a.192.192 0 0 1-.07.021c-.017 0-.026-.009-.044-.04a.092.092 0 0 1-.014-.054c0-.122.087-.352.201-.535a.698.698 0 0 1 .18-.213c-.028-.113-.1-.202-.187-.227l-.114-.033c-.016-.006-.027-.019-.027-.033 0-.035.055-.082.154-.135a.826.826 0 0 1 .367-.107c.11 0 .219.044.342.14.18.142.23.168.318.168.143 0 .278-.131.278-.268 0-.092-.049-.19-.177-.355-.186-.24-.242-.366-.242-.543 0-.11.034-.25.076-.312l.067-.1a.125.125 0 0 0 .022-.063c0-.045-.052-.078-.12-.078-.107 0-.309.076-.47.174-.08.049-.135.107-.135.143 0 .02.01.04.028.051l.074.047c.01.005.014.016.014.028 0 .009-.011.03-.027.051l-.134.174c-.07.09-.175.201-.28.294a.437.437 0 0 0-.068.067l-.053.1c-.048.09-.174.22-.295.301a.587.587 0 0 0-.093.074.564.564 0 0 0-.053.093c-.017.033-.046.08-.087.14a1.57 1.57 0 0 1-.16.208l-.187.187c-.058.057-.108.17-.187.413-.047.149-.09.235-.115.235-.01 0-.03-.015-.052-.04-.132-.152-.245-.241-.305-.241-.015 0-.04.01-.075.033a.52.52 0 0 1-.18.067l-.248.046c-.187.035-.26.076-.367.2-.026.03-.047.047-.058.047-.02 0-.036-.034-.036-.077l.007-.062.034-.18c.035-.193.079-.337.133-.435l.113-.208a.232.232 0 0 0 .033-.108c0-.155-.158-.295-.353-.313-.05-.004-.069-.017-.069-.044 0-.034.054-.1.129-.157.134-.101.308-.173.42-.173.067 0 .172.028.301.08l.147.06a.404.404 0 0 0 .15.034c.155 0 .306-.142.492-.46.084-.145.12-.25.12-.344 0-.17-.08-.272-.213-.272-.1 0-.21.048-.288.126-.067.068-.103.14-.103.208l.002.074v.016c0 .062-.02.098-.057.098-.063 0-.154-.09-.417-.408-.195-.237-.238-.338-.247-.575-.226-.289-.282-.412-.282-.617l.01-.138c-.157-.19-.202-.292-.202-.465 0-.063.01-.1.048-.176a.687.687 0 0 1-.127-.26L.873 2.86a.719.719 0 0 0-.107-.247C.706 2.527.7 2.514.7 2.485c0-.077.053-.108.288-.166a1.184 1.184 0 0 1-.014-.148c0-.039.004-.076.02-.16l.047-.248c.019-.1.028-.17.028-.213a.681.681 0 0 0-.049-.214.767.767 0 0 0-.06-.154.257.257 0 0 1-.04-.091c0-.024.016-.037.045-.037.068 0 .241.106.422.255.383.317.463.444.516.828.004.03.01.075.02.134.184.136.28.298.28.474a.83.83 0 0 1-.134.428l-.134.207a.403.403 0 0 0-.06.22c0 .127.037.242.127.401.103.18.19.254.298.254.176 0 .33-.307.33-.655v-.167a1.603 1.603 0 0 1 .013-.22 2.62 2.62 0 0 0 .02-.195l.007-.16.002-.106c0-.037-.02-.075-.07-.128l-.146-.16c-.212-.232-.329-.45-.329-.613 0-.204.146-.356.342-.356a.49.49 0 0 1 .14.026v-.045c0-.295.06-.513.142-.513l.033.01.12.107.147.094.04.04c0-.084.005-.092.088-.188.02-.022.05-.065.094-.127l.066-.1c.01-.016.022-.037.033-.06.017-.034.036-.049.055-.049.018 0 .034.024.058.098.016.045.026.058.141.16.04.035.067.064.08.087.01.018.029.063.053.133.004.012.01.03.02.054a.412.412 0 0 1 .134-.121l.1-.06a.224.224 0 0 1 .075-.035c.008 0 .021.016.032.04.01.025.029.058.053.101.071.124.095.184.095.242l-.003.066v.08c.22.07.302.183.302.42 0 .17-.09.364-.26.57-.116.137-.129.163-.129.259 0 .495.345.78.95.79l.448.006c.287.005.459.033.727.12.318.104.41.127.502.127.03 0 .061-.01.087-.027.024-.017.04-.04.04-.059 0-.093-.165-.169-.702-.321-1.102-.312-1.57-.756-1.57-1.486 0-.564.468-1.001 1.075-1.001.195 0 .496.052.668.114l.273.1c.051.019.099.029.145.029.093 0 .14-.077.143-.236.002-.084.021-.113.076-.113.077 0 .196.097.305.247.11.153.18.324.18.44 0 .152-.07.257-.234.349-.15.229-.334.333-.582.333-.193 0-.468-.108-.921-.367-.159-.09-.239-.12-.322-.12-.118 0-.195.069-.195.174 0 .097.074.159.27.227.289.102.36.14.475.261.34.059.488.118.702.28.586.187.95.586.95 1.045 0 .46-.302.767-.721.767-.1 0-.162-.007-.317-.041"
        />
        <path
          fill="#FFE500"
          d="M7.294 7.35a.714.714 0 0 1-.024-.162l.005-.052.02-.107.008-.087c0-.092-.017-.158-.047-.2l-.08-.106a.455.455 0 0 1-.08-.183c0-.03.018-.05.048-.05.018 0 .025.004.085.04a.14.14 0 0 0 .065.022c.04 0 .062-.064.062-.178 0-.13-.012-.2-.04-.233l-.1-.114-.086-.073c-.021-.018-.036-.04-.036-.058 0-.028.023-.048.055-.048.03 0 .095.014.149.033l.03.006c.027 0 .038-.016.038-.055l-.002-.024-.02-.14-.04-.147c-.014-.048-.02-.055-.051-.055l-.017.002-.167.033-.027.003c-.218 0-.45-.185-.52-.417l-.134-.434c-.042-.134-.141-.26-.321-.408a.293.293 0 0 0-.133-.072l-.121-.015c-.023-.002-.037-.015-.037-.033 0-.028.026-.04.083-.04l.221.02c.08.007.202.038.36.093.201.07.335.099.449.099.334 0 .535-.181.535-.483a.85.85 0 0 0-.274-.592c-.094-.084-.188-.147-.22-.147-.02 0-.034.015-.034.036l.007.085v.008c0 .034-.02.059-.045.059-.033 0-.072-.044-.114-.134-.126-.263-.328-.42-.535-.42-.036 0-.06.014-.06.036a.37.37 0 0 0 .033.096l.052.12a.222.222 0 0 1 .022.061c0 .007-.013.015-.029.015-.03 0-.079-.027-.113-.063l-.1-.106-.087-.135c-.07-.106-.127-.155-.275-.233a5.739 5.739 0 0 1-.16-.088.178.178 0 0 0-.084-.027c-.024 0-.035.011-.035.034 0 .022.009.047.025.073.05.076.068.113.068.134 0 .021-.016.04-.034.04-.052 0-.16-.105-.256-.248a.686.686 0 0 1-.12-.375c0-.287.209-.5.492-.5.147 0 .332.061.503.167l.314.194a.82.82 0 0 0 .364.12.93.93 0 0 0 .197-.033.334.334 0 0 0 .08-.034c.018-.011.031-.026.031-.038 0-.013-.007-.025-.018-.03l-.04-.012-.147-.028a.89.89 0 0 1-.18-.067 3.084 3.084 0 0 1-.334-.166 1.264 1.264 0 0 0-.22-.126c-.055-.019-.09-.043-.09-.064 0-.02.011-.029.031-.029s.044.01.071.025a.52.52 0 0 0 .247.094l.288.1c.142.05.35.094.444.094a.22.22 0 0 0 .22-.22.58.58 0 0 0-.116-.293c-.015-.023-.032-.035-.045-.035-.027 0-.042.02-.042.054l.007.054.01.08c0 .086-.058.154-.132.154a.346.346 0 0 1-.105-.022l-.434-.14c-.364-.118-.533-.153-.715-.153-.519 0-.915.357-.915.826 0 .531.373.874 1.297 1.191.908.312 1.035.387 1.035.622 0 .134-.136.254-.287.254a.923.923 0 0 1-.161-.013c-.03-.006-.182-.042-.454-.107a3.373 3.373 0 0 0-.832-.094c-.655 0-1.018.115-1.333.421-.078.077-.105.089-.195.089l-.045-.002-.093-.006H3.74c-.079 0-.136.036-.188.12l-.113.18a.094.094 0 0 1-.077.04c-.06 0-.095-.045-.163-.206a.573.573 0 0 0-.14-.201l-.135-.12c-.022-.02-.033-.038-.033-.051 0-.015.009-.037.026-.062.064-.094.087-.134.094-.174.018-.088.02-.093.057-.093.041 0 .052.04.057.194 0 .043.019.105.053.18l.074.16c.009.02.032.034.06.034.069 0 .156-.163.18-.335.019-.143.034-.188.063-.188.013 0 .024.005.03.015.007.01.027.05.06.12a.269.269 0 0 0 .087.1.277.277 0 0 0 .08.047h.009c.054 0 .072-.035.085-.16l.007-.067-.013-.094-.01-.064c0-.043.016-.07.04-.07.016 0 .033.01.05.027l.067.067c.045.044.09.066.132.066.056 0 .09-.022.09-.059 0-.032-.012-.064-.062-.154l-.047-.087c-.054-.1-.096-.14-.146-.14l-.067.006-.08.034a.166.166 0 0 1-.052.015c-.013 0-.022-.011-.022-.026 0-.06.039-.155.114-.273.053-.084.09-.265.107-.524.022-.349.069-.575.118-.575.033 0 .045.028.045.102l-.003.092-.002.064c0 .062.015.113.03.113.058 0 .126-.086.18-.224a.419.419 0 0 0 .034-.136l-.007-.032-.133-.248-.134-.04c-.025-.007-.042-.018-.047-.029v-.164l-.013-.08-.028-.067-.032-.073c-.146.08-.217.131-.267.2-.052.07-.083.097-.108.097-.017 0-.033-.017-.033-.036a.68.68 0 0 1 .02-.109l.005-.037a.46.46 0 0 0-.232-.376l-.04.053-.046.067-.08.093a.385.385 0 0 0-.08.21v.034c0 .056-.006.07-.03.07l-.017-.007-.046-.066-.074-.08-.113-.073-.06-.047a1.175 1.175 0 0 0-.027.06.347.347 0 0 0-.033.107l-.007.106-.007.113v.02c0 .058-.013.08-.048.08a.237.237 0 0 1-.079-.033.193.193 0 0 0-.096-.027c-.104 0-.17.072-.17.185 0 .133.039.26.107.35l.086.114c.025.03.068.056.07.04l.017-.14-.02-.114-.005-.051c0-.043.015-.07.04-.07.037 0 .06.041.084.154l.053.248.054.314c.014.085.042.174.08.268.053.126.092.204.114.233.074.096.082.109.082.13 0 .016-.013.03-.028.03a.147.147 0 0 1-.06-.02.266.266 0 0 0-.08-.026L2.897 3.3c-.108 0-.13.092-.13.538 0 .272.059.64.129.819l.14.354a.442.442 0 0 1 .034.166c0 .488-.647 1.252-1.356 1.605-.264.13-.349.256-.367.548l-.007.087a.923.923 0 0 1 .226-.093c.2-.052.238-.078.268-.174l.026-.088c.01-.032.028-.044.181-.127a.27.27 0 0 0 .107-.086c.033-.056.06-.086.08-.086.015 0 .024.008.024.021l-.005.023-.066.191-.008.047c0 .141.077.257.222.33.023-.154.04-.207.087-.28l.12-.187c.045-.07.063-.154.063-.286 0-.075-.006-.151-.016-.208l-.004-.053c0-.033.017-.054.047-.054.023 0 .041.008.044.02l.028.127c.005.027.032.046.065.046.064 0 .148-.083.236-.233a.353.353 0 0 0 .05-.177L3.104 6l-.021-.1-.002-.02c0-.043.024-.074.059-.074.015 0 .027.006.03.013l.039.155c.013.05.05.087.086.087.045 0 .122-.077.167-.167.04-.08.06-.17.06-.274 0-.142.015-.183.067-.183.017 0 .03.006.034.017l.026.087c.01.031.03.053.048.053.027 0 .102-.081.152-.167a.127.127 0 0 0 .02-.062c0-.028-.019-.057-.06-.091-.07-.058-.074-.066-.074-.154 0-.087.014-.128.075-.234.032-.056.06-.11.086-.16.084-.166.115-.207.145-.207.026 0 .049.027.049.059a.113.113 0 0 1-.014.054.223.223 0 0 0-.028.08c0 .026.023.047.05.047.03 0 .071-.014.118-.04.018-.01.08-.034.187-.073l.22-.08a.529.529 0 0 1 .254-.007c.08.017.13.027.155.027.06 0 .114-.052.114-.112 0-.045-.046-.132-.108-.203-.023-.027-.034-.047-.034-.061l.008-.027c.009-.016.022-.026.035-.026.045 0 .15.113.245.26.576.906.782 1.126 1.17 1.243.391.12.494.211.494.445 0 .128-.065.276-.208.477-.29.406-.361.57-.361.84v.049a1.37 1.37 0 0 0 .074-.034.575.575 0 0 1 .107-.046l.167-.034c.05-.01.094-.075.094-.136v-.017l-.021-.148-.002-.019c0-.052.026-.112.062-.141a.06.06 0 0 1 .034-.014c.019 0 .04.017.052.041l.107.227c.043.092.094.137.234.2M1.908 2.506c-.05 0-.075.042-.08.134l-.013.127a1.155 1.155 0 0 0-.016.162c0 .096.028.167.067.167.043 0 .11-.082.143-.175a.453.453 0 0 0 .03-.156.471.471 0 0 0-.03-.151c-.024-.068-.06-.107-.101-.107"
        />
        <path
          fill="#FFE500"
          d="m1.355 1.532.093.093c.153.153.228.406.228.765 0 .08-.004.132-.02.344a4.027 4.027 0 0 0-.013.275c0 .829.269 1.456.626 1.456.111 0 .185-.054.29-.214.018-.026.044-.048.06-.048.022 0 .032.018.033.055l.013.148.013.127.013.14.02.127v.016c.002.037-.015.058-.046.063l-.12.02a.52.52 0 0 0-.187.074c-.1.06-.162.107-.174.133l-.073.154c-.01.02-.026.034-.042.034-.038 0-.1-.068-.172-.187a.639.639 0 0 1-.098-.219c0-.02.016-.029.059-.029h.013l.087.007.052-.007.06-.006a.047.047 0 0 0 .041-.047.043.043 0 0 0-.027-.04l-.301-.127a.468.468 0 0 1-.227-.22c-.083-.158-.12-.252-.12-.3 0-.04.02-.068.053-.068.011 0 .028.005.047.014.03.014.069.027.084.027.027 0 .05-.02.05-.042 0-.018-.024-.05-.054-.072-.25-.182-.395-.391-.395-.572 0-.05.012-.075.038-.075l.05.006.086.013h.004c.032 0 .058-.022.058-.052 0-.018-.023-.044-.055-.061a8.451 8.451 0 0 0-.107-.06.287.287 0 0 1-.094-.095 4.626 4.626 0 0 1-.112-.213l-.094-.18-.06-.114a.602.602 0 0 0-.04-.054.424.424 0 0 1 .208-.053c.091 0 .15.06.213.221.041.103.086.17.11.17.013 0 .017-.021.017-.077a.747.747 0 0 0-.027-.2.461.461 0 0 1-.02-.147l-.014-.093-.08-.04c-.018-.008-.039-.033-.06-.066a.283.283 0 0 1-.053-.153c0-.028.007-.074.02-.12.069-.256.088-.355.088-.438v-.057l.059.066-.001-.002ZM2.156 6.348A.753.753 0 0 1 1.96 6.3l-.127-.053a.682.682 0 0 0-.255-.068c-.1 0-.183.035-.278.114l.06.047.133.093.127.1c.032.027.071.042.11.042.13 0 .245-.061.423-.228M4.728 7.564a.373.373 0 0 1 .135-.173c.187-.16.273-.28.273-.374v-.148c0-.085.014-.114.059-.114.02 0 .035.009.042.02l.033.08c.008.02.03.03.057.03.026 0 .064-.03.098-.078l.067-.093a.219.219 0 0 0 .048-.13.205.205 0 0 0-.015-.078L5.478 6.4a.32.32 0 0 1-.027-.105c0-.044.022-.069.06-.069a.06.06 0 0 1 .048.021l.054.066c.01.015.03.024.05.024.025 0 .053-.024.07-.056l.053-.107a.156.156 0 0 0 .022-.06c0-.02-.022-.042-.061-.06l-.088-.04c-.115-.053-.2-.237-.2-.428 0-.026.004-.051.013-.072L5.52 5.4a.277.277 0 0 0 .02-.107c0-.07-.023-.14-.067-.207a2.045 2.045 0 0 1-.087-.14c-.04-.106-.06-.136-.093-.136l-.033.008-.047.027-.074.04-.086.108-.094.046c-.056.028-.109.147-.109.246 0 .174.02.221.25.617.089.152.136.284.136.382 0 .273-.245.468-.737.586l-.307.074c-.227.054-.36.209-.408.474.094-.049.13-.055.296-.055h.099l.015.001c.09 0 .101-.006.157-.087a.503.503 0 0 1 .22-.186l.108-.047.087-.047.026-.007c.025 0 .037.01.037.028 0 .026-.024.07-.063.113a.351.351 0 0 0-.107.259c0 .064.015.101.073.176"
        />
        <path
          fill="#FFE500"
          d="M3.887 6.529a.773.773 0 0 1 .201.18c.064.087.073.093.136.093.028 0 .06-.005.098-.014l.06-.013c.11-.022.147-.038.147-.064 0-.017-.012-.037-.034-.056l-.073-.067-.073-.067a.364.364 0 0 0-.22-.075c-.08 0-.127.016-.241.082M6.052 6.89l.04-.007.06-.007.06.007.029.002c.148 0 .29-.126.29-.259 0-.045-.041-.07-.117-.07-.18 0-.293.103-.363.334"
        />
        <path
          fill="#0C0D0D"
          d="M3.559 2.273c.007.063.04.113.072.113.028 0 .06-.074.13-.19.095-.161.185-.318.185-.403 0-.029-.014-.05-.033-.05l-.008.002-.073.067c-.053.048-.095.071-.227.12-.076.028-.103.059-.103.114l.01.054.033.093.013.08ZM3.152 1.925l.113.06c.031.016.049.038.049.064l-.008.042c-.017.055-.003.118-.004.142-.007.12-.097.118-.134.118-.022 0-.01-.014-.063-.074l-.147-.167c-.046-.05-.084-.169-.1-.3v-.017c0-.037.01-.05.04-.05.017 0 .05.015.073.035l.181.146ZM3.412 2.627h-.036L3.3 2.62c-.002 0-.029-.016-.08-.048a.194.194 0 0 0-.096-.026c-.06 0-.1.033-.1.084 0 .055.028.147.089.297l.087.213c.076.188.15.268.25.268.087 0 .099-.087.158-.234.133-.335.208-.385.208-.504 0-.081-.018-.103-.091-.103l-.062-.015-.107.068-.14.007h-.003Z"
        />
        <path
          fill="#FFE500"
          d="M3.406 2.814h-.088a.04.04 0 0 0-.033.02l-.014.034.034.16.026.14c.016.078.043.109.101.109.065 0 .106-.045.113-.127l.013-.148c.01-.097.013-.148.013-.152a.055.055 0 0 0-.02-.04.05.05 0 0 0-.034-.015h-.006l-.106.021v-.002Z"
        />
        <path
          fill="#1D1D1B"
          d="m19.1 4.424.026.1c.025.091.042.162.054.214.084.382.155.482.34.482.107 0 .195-.06.221-.148l.04-.134a.063.063 0 0 1 .063-.047c.073 0 .112.08.117.241.002.062.015.171.04.328.018.113.027.216.027.309a.467.467 0 0 1-.04.192l.014.08c.022.132.028.183.028.245 0 .287-.014.37-.081.483.027.11.035.16.035.24 0 .05-.007.123-.021.234l-.027.2.007.12a.323.323 0 0 1 .026.08c0 .02-.012.034-.026.034l-.134-.054-.146-.08a.692.692 0 0 1-.153-.12c-.13.114-.148.125-.302.167-.222.06-.303.09-.347.12-.042.031-.075.047-.092.047-.052 0-.089-.101-.089-.248 0-.215.012-.325.047-.408a.864.864 0 0 0-.243-.06.518.518 0 0 0-.097.013l-.03.003c-.02 0-.03-.023-.03-.064 0-.065.045-.196.107-.306.084-.149.222-.273.328-.294l.24-.046c.143-.028.228-.104.228-.203 0-.1-.062-.16-.208-.212l-.28-.1a1.438 1.438 0 0 1-.268-.127c-.07-.044-.12-.073-.146-.088a.155.155 0 0 0-.073-.02c-.06 0-.096.045-.096.116 0 .113.087.206.194.206a.19.19 0 0 0 .068-.013.21.21 0 0 1 .061-.02c.03 0 .052.029.052.07a.843.843 0 0 1-.153.423l-.08.101-.06.08c-.023.172-.192.42-.361.528a.463.463 0 0 0-.075.053.79.79 0 0 0-.053.093c-.014.026-.058.08-.134.16a1.198 1.198 0 0 1-.166.154.616.616 0 0 0-.134.121l-.067.114c-.013.023-.03.035-.051.035-.06 0-.115-.062-.149-.168-.024-.078-.045-.1-.096-.1a.527.527 0 0 0-.117.02l-.094.013h-.235c-.125 0-.295.03-.373.067a.181.181 0 0 1-.07.021c-.034 0-.051-.034-.051-.101 0-.213.163-.534.375-.741-.032-.123-.097-.206-.181-.227a2.26 2.26 0 0 1-.12-.034.036.036 0 0 1-.02-.031c0-.043.047-.085.154-.135.19-.09.245-.107.352-.107.12 0 .223.04.35.14.18.142.23.168.317.168.142 0 .28-.13.28-.267 0-.093-.051-.195-.177-.355-.178-.228-.241-.375-.241-.568 0-.13.025-.2.14-.387a.163.163 0 0 0 .029-.071c0-.037-.061-.07-.128-.07a.715.715 0 0 0-.28.08c-.202.093-.322.179-.322.231 0 .02.012.042.034.057l.067.047a.035.035 0 0 1 .014.028c0 .01-.013.034-.028.051a6.142 6.142 0 0 0-.134.174 1.528 1.528 0 0 1-.28.294.279.279 0 0 0-.067.067l-.053.1a1.144 1.144 0 0 1-.288.301.782.782 0 0 0-.093.074.583.583 0 0 0-.06.093 1.971 1.971 0 0 1-.247.348l-.181.187c-.052.053-.125.208-.194.413-.055.163-.09.235-.115.235-.011 0-.03-.015-.052-.04-.13-.149-.246-.241-.303-.241a.218.218 0 0 0-.078.033.556.556 0 0 1-.18.067l-.24.046c-.202.04-.282.082-.375.2-.023.03-.042.047-.053.047-.023 0-.041-.035-.041-.081l.007-.06c.002-.005.013-.065.034-.18.035-.19.084-.347.133-.434l.121-.208a.227.227 0 0 0 .034-.107c0-.155-.143-.28-.36-.313-.045-.006-.068-.024-.068-.048 0-.03.052-.09.134-.152.143-.106.298-.173.409-.173.074 0 .174.026.306.08l.147.06a.404.404 0 0 0 .15.035c.155 0 .305-.143.492-.462.085-.145.12-.249.12-.343 0-.17-.078-.272-.21-.272a.4.4 0 0 0-.285.126c-.073.074-.11.148-.11.214l.004.068.003.035c0 .054-.019.079-.058.079-.051 0-.11-.05-.225-.188l-.187-.221c-.203-.238-.245-.332-.254-.575-.226-.289-.282-.45-.282-.617l.009-.138c-.163-.195-.194-.27-.194-.463a.3.3 0 0 1 .04-.179.673.673 0 0 1-.127-.26l-.033-.141a.73.73 0 0 0-.107-.247c-.06-.086-.067-.099-.067-.124 0-.07.067-.115.235-.157l.053-.013a1.132 1.132 0 0 1-.014-.148c0-.039.005-.076.02-.16l.047-.248c.019-.096.028-.17.028-.22a.663.663 0 0 0-.04-.207.58.58 0 0 0-.068-.154c-.025-.037-.04-.068-.04-.088 0-.024.023-.041.052-.041.016 0 .045.008.067.021.226.123.473.318.649.514.151.168.199.308.234.682.205.152.281.29.281.508 0 .129-.042.253-.134.394a8.82 8.82 0 0 0-.133.207.445.445 0 0 0-.06.227c0 .12.036.234.127.394.1.177.189.254.296.254.174 0 .333-.303.333-.636v-.066l-.001-.18.02-.16.013-.194.014-.16.005-.09c0-.066-.014-.084-.22-.304-.226-.243-.334-.449-.334-.639 0-.18.154-.33.34-.33.038 0 .072.007.14.026v-.08l.008-.141.04-.173c.032-.138.046-.164.094-.164l.032.01.121.107.147.094.04.04c.01-.084.018-.1.087-.188a2.12 2.12 0 0 0 .093-.127l.067-.1.04-.06c.027-.04.04-.05.057-.05.018 0 .03.023.052.098.009.03.03.06.06.086l.087.073c.07.06.117.148.146.275a.401.401 0 0 1 .134-.121l.106-.06a.282.282 0 0 1 .071-.034c.008 0 .019.016.03.04.015.035.033.07.054.101.086.139.093.159.093.252v.136c.218.06.301.177.301.417 0 .18-.082.365-.254.573-.114.137-.133.18-.133.283 0 .472.354.756.955.765l.441.007c.289.005.465.034.729.12.309.102.41.127.504.127.068 0 .124-.038.124-.083 0-.096-.162-.172-.701-.324-1.1-.311-1.57-.756-1.57-1.485 0-.565.471-1.001 1.08-1.001.192 0 .492.05.664.114l.273.1c.05.019.099.029.143.029.095 0 .13-.06.145-.236.006-.078.031-.113.08-.113.071 0 .207.11.307.247.101.142.174.328.174.448 0 .143-.075.251-.235.34-.15.23-.335.334-.582.334-.19 0-.514-.129-.921-.367-.16-.093-.231-.12-.32-.12-.12 0-.198.068-.198.174 0 .097.072.157.27.227.316.113.384.15.474.261.34.059.488.118.702.28.61.196.949.573.949 1.055 0 .439-.298.756-.712.756-.11 0-.167-.006-.325-.04"
        />
        <path
          fill="#FFE500"
          d="M19.76 7.35a.494.494 0 0 1-.02-.123l.008-.091c.016-.125.02-.185.02-.26a.208.208 0 0 0-.048-.135l-.08-.106c-.052-.07-.073-.123-.073-.182 0-.039.009-.052.035-.052l.03.006.06.033c.028.016.05.023.068.023.04 0 .06-.063.06-.188 0-.174-.033-.257-.134-.337l-.093-.073a.074.074 0 0 1-.027-.055c0-.032.019-.052.048-.052a.33.33 0 0 1 .079.014l.074.02.028.006c.023 0 .034-.017.034-.057v-.023l-.022-.14c-.02-.146-.044-.202-.088-.202h-.012l-.174.035-.03.003c-.208 0-.455-.198-.518-.417l-.127-.434c-.037-.13-.151-.273-.321-.408a.31.31 0 0 0-.14-.072l-.12-.015c-.023-.002-.037-.015-.037-.032 0-.028.024-.04.072-.04.17 0 .351.034.593.113.22.072.34.099.446.099.335 0 .536-.175.536-.464a.907.907 0 0 0-.127-.443 1.066 1.066 0 0 0-.314-.294.108.108 0 0 0-.053-.021.034.034 0 0 0-.035.034l.007.086v.008c0 .033-.018.059-.042.059-.037 0-.076-.044-.118-.134-.123-.261-.321-.419-.526-.419-.044 0-.07.015-.07.043 0 .02.012.05.035.088a.728.728 0 0 1 .06.12.2.2 0 0 1 .016.057c0 .012-.01.02-.03.02-.03 0-.08-.028-.113-.064l-.101-.106-.086-.135a.63.63 0 0 0-.268-.233l-.167-.088a.205.205 0 0 0-.086-.027c-.02 0-.031.01-.031.03 0 .02.01.048.03.078a.339.339 0 0 1 .062.133c0 .022-.014.04-.033.04-.047 0-.13-.084-.25-.247a.636.636 0 0 1-.127-.375c0-.281.216-.5.496-.5.143 0 .322.06.5.167l.32.194c.116.07.27.12.368.12a.618.618 0 0 0 .188-.033.312.312 0 0 0 .086-.034c.014-.01.024-.024.024-.04 0-.026-.016-.037-.057-.04-.149-.011-.458-.133-.661-.261a1.653 1.653 0 0 0-.22-.126c-.055-.02-.092-.048-.092-.072 0-.01.011-.016.028-.016l.039.007.292.107.28.1c.137.05.352.094.45.094a.204.204 0 0 0 .214-.214.439.439 0 0 0-.042-.186c-.04-.08-.094-.148-.116-.148-.026 0-.04.027-.04.071l.003.036.008.086c0 .09-.05.149-.126.149a.362.362 0 0 1-.11-.022l-.434-.14c-.377-.122-.524-.153-.71-.153-.524 0-.92.354-.92.826 0 .533.366.866 1.303 1.191.91.315 1.028.387 1.028.627 0 .138-.129.248-.29.248a.874.874 0 0 1-.157-.013c-.04-.008-.19-.044-.454-.107a3.3 3.3 0 0 0-.83-.094c-.663 0-.982.101-1.328.421-.08.075-.111.089-.201.089l-.045-.002-.105-.007c-.08 0-.14.038-.19.12l-.106.182a.087.087 0 0 1-.076.04c-.07 0-.106-.047-.171-.207a.524.524 0 0 0-.133-.201l-.14-.12c-.022-.019-.034-.036-.034-.049 0-.013.012-.036.034-.064a.595.595 0 0 0 .093-.175l.006-.06c.005-.02.024-.033.048-.033.045 0 .052.03.053.194a.49.49 0 0 0 .053.18l.073.16c.01.02.033.034.06.034.07 0 .157-.163.18-.335.019-.142.034-.188.064-.188.027 0 .04.018.096.135.018.035.045.07.08.1.033.028.06.044.08.047h.008c.055 0 .073-.035.086-.16l.006-.067-.013-.094-.009-.064c0-.043.015-.07.04-.07.014 0 .032.01.05.027l.067.067c.044.045.089.067.134.067.057 0 .092-.025.092-.066 0-.033-.008-.05-.067-.148l-.047-.087c-.059-.112-.087-.14-.139-.14l-.068.006-.087.034a.18.18 0 0 1-.053.015c-.011 0-.02-.011-.02-.027 0-.06.039-.156.113-.272.046-.072.085-.252.113-.524l.034-.314c.02-.193.041-.261.08-.261.014 0 .025.006.026.014l.02.1v.08c0 .097.01.176.022.176.028 0 .07-.033.11-.089a.62.62 0 0 0 .1-.308c.001-.154-.064-.22-.273-.28-.021-.005-.035-.013-.04-.02l-.007-.06v-.113l-.013-.08-.026-.067-.034-.073-.053.033c-.136.086-.17.111-.214.167-.061.077-.082.096-.107.096-.018 0-.032-.014-.032-.029l.026-.114.002-.019c0-.146-.082-.288-.23-.394l-.046.053-.047.067-.08.093a.31.31 0 0 0-.075.198v.023l.001.022c0 .053-.008.071-.032.071l-.014-.006-.054-.066-.067-.08-.12-.073-.06-.047c-.064.14-.067.154-.067.334v.056c0 .06-.02.097-.052.097a.202.202 0 0 1-.082-.034.207.207 0 0 0-.1-.027c-.097 0-.168.082-.168.195 0 .122.027.206.108.34.052.086.122.156.153.156a.774.774 0 0 0 .02-.143l-.02-.114-.004-.051c0-.043.016-.07.041-.07.038 0 .06.041.084.154l.054.248.053.314c.014.085.042.174.08.268.053.126.09.204.113.233.074.096.083.109.083.13 0 .016-.014.03-.03.03a.147.147 0 0 1-.06-.02.266.266 0 0 0-.08-.026l-.049-.007c-.11 0-.133.09-.133.533 0 .276.057.645.128.824l.14.355a.442.442 0 0 1 .034.165c0 .489-.66 1.27-1.357 1.605-.27.13-.35.265-.374.635.116-.055.162-.073.234-.093.197-.055.239-.084.267-.174l.026-.088c.012-.036.037-.054.174-.127a.268.268 0 0 0 .107-.086c.034-.058.062-.086.08-.086.018 0 .029.013.029.034v.01l-.076.191-.008.047c0 .14.079.257.223.33l.02-.08a.702.702 0 0 1 .066-.2l.127-.187c.046-.067.054-.112.054-.285l-.008-.21-.004-.054c0-.034.016-.054.047-.054.023 0 .042.01.043.02l.02.128c.005.027.032.046.065.046.065 0 .147-.082.236-.233a.303.303 0 0 0 .047-.16c0-.043-.009-.136-.021-.207l-.003-.04c0-.033.02-.054.05-.054.018 0 .03.005.033.012l.047.155c.016.05.05.087.087.087.103 0 .209-.209.22-.434.007-.14.024-.19.067-.19.016 0 .03.006.034.017l.026.087c.01.031.03.053.048.053.017 0 .05-.03.092-.08a.583.583 0 0 0 .06-.088.144.144 0 0 0 .02-.07c0-.034-.008-.043-.06-.083a.17.17 0 0 1-.074-.14c0-.097.041-.202.16-.408.109-.187.124-.21.15-.21.026 0 .045.025.045.057 0 .02-.005.04-.014.06a.233.233 0 0 0-.028.08c0 .026.024.047.053.047a.273.273 0 0 0 .121-.04c.029-.015.09-.04.181-.073.124-.045.2-.073.227-.08a.462.462 0 0 1 .254-.008.837.837 0 0 0 .153.028c.061 0 .108-.047.108-.106a.282.282 0 0 0-.042-.116c-.034-.055-.055-.087-.06-.093-.03-.03-.04-.048-.04-.06l.007-.028c.008-.016.022-.026.037-.026.053 0 .157.107.25.26.523.857.777 1.127 1.162 1.243.402.122.496.206.496.446 0 .127-.067.28-.208.476-.268.37-.361.587-.361.834v.055c.034-.014.058-.025.074-.034a.609.609 0 0 1 .107-.046l.166-.034c.053-.01.095-.073.095-.14V7.2l-.013-.148V7.03c-.001-.083.038-.151.088-.151.018 0 .04.017.051.04l.107.227c.043.092.094.137.233.2M14.283 2.767l-.008.107-.002.065c0 .109.018.156.058.156.045 0 .114-.084.146-.174a.672.672 0 0 0 .034-.181.329.329 0 0 0-.034-.127c-.03-.073-.061-.107-.099-.107-.057 0-.083.073-.095.261Z"
        />
        <path
          fill="#FFE500"
          d="m13.82 1.532.094.093c.136.137.231.415.231.684l-.003.11-.02.315-.008.263c0 .873.255 1.469.628 1.469.093 0 .209-.087.287-.215.018-.027.04-.048.054-.048.02 0 .032.019.034.055l.013.148.013.127c.007.06.013.106.02.14.014.064.02.109.02.131 0 .067-.012.074-.173.097a.45.45 0 0 0-.187.073.687.687 0 0 0-.174.133l-.073.154c-.01.02-.027.034-.043.034-.04 0-.091-.059-.164-.187-.069-.118-.098-.186-.098-.217 0-.022.016-.031.058-.031h.014l.08.007.06-.007.054-.006a.05.05 0 0 0 .04-.049.041.041 0 0 0-.027-.037l-.301-.127a.554.554 0 0 1-.22-.22c-.078-.123-.123-.23-.123-.29 0-.048.02-.079.052-.079.012 0 .03.004.049.015a.237.237 0 0 0 .078.027.064.064 0 0 0 .036-.013c.013-.01.02-.023.02-.033 0-.02-.02-.044-.053-.068-.25-.177-.401-.392-.401-.57 0-.052.012-.076.037-.076l.05.005c.037.007.08.013.094.013.036 0 .06-.02.06-.052 0-.02-.024-.044-.06-.062-.167-.083-.208-.131-.315-.368a1.485 1.485 0 0 0-.194-.348.42.42 0 0 1 .208-.053c.091 0 .15.06.213.221.04.103.086.17.11.17.013 0 .018-.02.018-.076a.758.758 0 0 0-.027-.2.43.43 0 0 1-.02-.148l-.013-.093-.074-.04c-.068-.037-.114-.125-.114-.219 0-.041.004-.083.013-.12l.041-.155c.028-.109.048-.222.048-.282v-.058l.059.066v-.003ZM14.622 6.348a.975.975 0 0 1-.32-.1.608.608 0 0 0-.25-.068.41.41 0 0 0-.284.115l.06.047.134.093.127.101c.032.026.072.04.111.04.132 0 .242-.06.422-.227M17.196 7.565a.38.38 0 0 1 .134-.174c.187-.16.274-.28.274-.374v-.148c0-.085.014-.113.059-.113.02 0 .036.008.041.02l.034.08c.008.017.03.029.057.029.048 0 .081-.035.163-.17.035-.057.05-.095.05-.132a.195.195 0 0 0-.017-.075 5.512 5.512 0 0 0-.047-.107.321.321 0 0 1-.027-.105c0-.044.022-.069.06-.069a.06.06 0 0 1 .047.021l.053.066c.012.015.016.024.036.024a.117.117 0 0 0 .085-.056l.054-.107a.16.16 0 0 0 .02-.06c0-.023-.02-.047-.053-.06l-.094-.04c-.11-.047-.2-.235-.2-.414 0-.02.007-.05.02-.086l.04-.114a.337.337 0 0 0 .021-.111.37.37 0 0 0-.067-.203 1.393 1.393 0 0 1-.08-.14c-.039-.1-.062-.133-.095-.133-.023 0-.045.008-.085.032l-.067.04-.094.108-.093.046c-.056.028-.109.15-.109.25 0 .144.032.223.25.612.093.164.136.286.136.38 0 .272-.277.496-.73.588-.542.111-.66.2-.722.548.093-.049.131-.055.296-.055h.097l.016.001c.089 0 .101-.006.158-.087a.492.492 0 0 1 .22-.186l.107-.047.087-.047.026-.007c.025 0 .037.01.037.028 0 .023-.022.06-.064.113a.38.38 0 0 0-.102.22c0 .09.015.134.068.215"
        />
        <path
          fill="#FFE500"
          d="M16.354 6.529a.766.766 0 0 1 .2.18c.064.087.073.093.136.093.026 0 .06-.005.098-.014l.06-.013c.113-.022.148-.038.148-.068 0-.019-.01-.037-.029-.052l-.08-.067-.073-.067a.36.36 0 0 0-.21-.074.457.457 0 0 0-.25.08M18.518 6.89l.04-.007.066-.007.054.007.037.002c.068 0 .102-.008.13-.03a.54.54 0 0 0 .128-.153.156.156 0 0 0 .026-.076c0-.044-.041-.07-.113-.07-.183 0-.296.102-.367.334"
        />
        <path
          fill="#0C0D0D"
          d="M16.027 2.274c.007.062.04.112.073.112.028 0 .072-.095.142-.213.095-.162.173-.296.173-.381 0-.029-.014-.05-.034-.05l-.007.002-.073.067a.761.761 0 0 1-.22.12c-.086.03-.11.057-.11.113l.01.054.056.116-.01.058v.002ZM15.44 1.779a.15.15 0 0 0-.075-.035c-.029 0-.04.014-.04.049l.001.02a.684.684 0 0 0 .027.112c.033.106.072.17.087.187l.1.169a.356.356 0 0 0 .146.092h.005c.018 0 .033-.011.035-.026l.02-.134.034-.121.004-.029c0-.032-.019-.06-.051-.078l-.114-.06-.18-.146ZM15.88 2.627h-.036l-.079-.007-.08-.048a.186.186 0 0 0-.093-.026c-.061 0-.098.037-.098.103 0 .05.03.147.085.278.025.056.053.127.088.213.073.187.15.268.25.268.086 0 .156-.071.21-.214l.075-.3c.035-.094.123-.134.123-.199 0-.077-.085-.15-.158-.15l-.039.007-.1.068-.147.007h-.002Z"
        />
        <path
          fill="#FFE500"
          d="M15.872 2.814h-.08c-.012 0-.024.007-.033.02a.15.15 0 0 0-.02.034l.033.16.026.14c.015.078.028.109.086.109.066 0 .12-.045.128-.127l.013-.148.013-.152a.057.057 0 0 0-.02-.04.052.052 0 0 0-.034-.015h-.006l-.107.021.001-.002Z"
        />
        <path
          fill="#1D1D1B"
          d="M6.76 17.038c.058.147.079.22.087.315l.013.28c.011.282.104.421.28.421.064 0 .117-.016.148-.047l.073-.073.03-.008c.046 0 .072.03.072.087l-.009.11c-.005.048.004.151.027.306.013.091.02.18.02.27 0 .142-.01.196-.06.325.047.13.073.279.073.403 0 .145-.023.243-.08.325a.904.904 0 0 1 .034.227c0 .065-.01.151-.027.254-.023.14-.032.247-.027.32v.017c0 .042-.012.063-.038.063-.025 0-.056-.019-.082-.052-.04-.052-.067-.072-.098-.072-.045 0-.06.025-.129.225a.913.913 0 0 1-.16.248.57.57 0 0 0-.12.194c-.02.08-.034.126-.039.14-.008.018-.023.032-.04.033h-.009c-.11 0-.235-.236-.366-.681-.036-.126-.083-.182-.151-.182a.132.132 0 0 0-.116.075l-.04.094c-.007.016-.02.026-.035.026-.053 0-.135-.097-.185-.22a.841.841 0 0 1-.065-.307c0-.21.154-.366.62-.628.203-.114.281-.26.281-.52 0-.208-.062-.327-.24-.462-.142-.107-.223-.148-.298-.148-.063 0-.113.043-.113.096 0 .063.037.1.124.131.103.037.147.073.147.119 0 .043-.043.133-.114.242a.619.619 0 0 1-.213.22c-.031.184-.118.301-.321.434a.692.692 0 0 1-.134.247l-.14.181a.584.584 0 0 0-.1.208c-.015.101-.025.12-.063.12-.053 0-.162-.095-.27-.234a.32.32 0 0 1-.087-.22c-.07.054-.091.061-.228.08a.538.538 0 0 0-.18.047c-.102.054-.136.068-.154.068-.027 0-.036-.014-.04-.062l-.007-.147c0-.201.08-.437.2-.595-.116-.101-.233-.163-.327-.173-.04-.004-.05-.01-.05-.024 0-.024.027-.077.064-.123.05-.063.09-.107.12-.133a.66.66 0 0 1 .387-.14c.087 0 .214.032.38.093a.46.46 0 0 0 .16.034c.074 0 .115-.048.115-.132 0-.121-.06-.311-.195-.617-.091-.206-.132-.346-.132-.441 0-.232.11-.472.246-.54a.28.28 0 0 0-.15-.041.376.376 0 0 0-.205.067c-.098.058-.154.108-.154.142 0 .013.02.034.054.058.051.036.06.05.06.098 0 .165-.136.386-.328.53a.59.59 0 0 1-.36.475c-.028.127-.045.163-.148.308-.175.244-.215.322-.247.46-.016.072-.032.102-.055.102-.028 0-.087-.045-.151-.115a1.118 1.118 0 0 1-.107-.128.634.634 0 0 1-.073-.214.296.296 0 0 1-.096.017l-.098-.004-.067-.002a.835.835 0 0 0-.381.082.145.145 0 0 1-.058.026c-.043 0-.079-.09-.079-.202 0-.241.068-.441.224-.659a1.192 1.192 0 0 1-.127-.12.21.21 0 0 0-.053-.046l-.073-.04c-.025-.013-.04-.03-.04-.044 0-.035.097-.129.213-.203.128-.083.23-.12.323-.12.11 0 .168.027.305.146.094.084.16.121.205.121.033 0 .068-.022.096-.06a.17.17 0 0 0 .034-.1c0-.128-.152-.344-.32-.456a.735.735 0 0 0-.4-.127.45.45 0 0 0-.416.241l-.074.154c-.017.035-.039.054-.063.054-.043 0-.065-.02-.218-.195l-.173-.2a.545.545 0 0 1-.108-.174.406.406 0 0 0-.034-.087.387.387 0 0 0-.066-.054c-.134-.094-.232-.282-.287-.554-.005-.019-.01-.048-.02-.086-.164-.2-.262-.45-.262-.665 0-.028.002-.041.014-.091-.095-.096-.105-.12-.18-.375-.055-.182-.088-.26-.154-.347-.017-.023-.027-.041-.027-.052 0-.035.056-.066.154-.082.091-.015.098-.015.134-.015l.133.009-.008-.183c0-.108.008-.177.036-.305a.787.787 0 0 0 .02-.14 1.242 1.242 0 0 0-.047-.27c0-.022.014-.034.04-.034.02 0 .047.01.088.03.116.056.213.115.287.173.23.181.412.459.412.63l-.004.052a2.1 2.1 0 0 0-.014.098c0 .03.017.067.047.108l.073.101a.508.508 0 0 1 .108.262c0 .062-.013.09-.121.246-.081.117-.114.204-.114.3a.9.9 0 0 0 .134.422c.079.138.17.214.257.214.15 0 .215-.132.238-.489.012-.185.03-.352.054-.507l.007-.091c0-.042-.013-.066-.067-.13l-.201-.233c-.191-.223-.25-.337-.25-.498 0-.184.122-.31.297-.31l.08.006v-.052c0-.042.01-.103.033-.182.042-.143.095-.254.122-.254.01 0 .032.011.065.034.01.006.051.022.121.047a.728.728 0 0 1 .134.066.583.583 0 0 1 .107-.234c.087-.112.184-.2.219-.2.02 0 .06.028.108.08l.127.134a.46.46 0 0 1 .073.127l.026.06.08-.046c.052-.031.089-.051.107-.06l.127-.06a.199.199 0 0 1 .068-.034c.023 0 .035.04.086.261.034.152.038.184.046.295.214.03.314.152.314.381 0 .216-.105.43-.333.674-.062.067-.077.098-.077.161 0 .59.205.778.946.855.454.048.59.076 1.135.241.288.085.453.122.56.122.125 0 .196-.046.196-.127 0-.124-.089-.163-.622-.276-1.237-.26-1.723-.682-1.723-1.5a.994.994 0 0 1 1.016-1.019c.256 0 .485.078.848.287.336.195.405.228.482.228.09 0 .125-.058.125-.202 0-.093.029-.14.087-.14.053 0 .134.056.207.141.111.131.154.198.154.38 0 .241-.13.399-.381.469-.028.03-.047.05-.06.066-.138.155-.259.207-.478.207-.19 0-.429-.077-.593-.194l-.32-.227c-.138-.098-.24-.14-.336-.14-.136 0-.219.081-.219.219 0 .137.089.244.234.288l.3.094c.108.033.158.054.288.12a.918.918 0 0 1 .149-.015c.187 0 .388.05.565.14a.902.902 0 0 0 .12.055l.168.046c.379.107.688.53.688.945 0 .473-.306.766-.801.766l-.155-.007v-.001Z"
        />
        <path
          fill="#FFE500"
          d="m6.647 21.006.04-.08.093-.1a.494.494 0 0 0 .122-.346.75.75 0 0 0-.035-.216.505.505 0 0 1-.027-.118c0-.043.031-.083.064-.083.013 0 .031.012.05.034l.1.113c.062.07.084.083.16.1l.008-.093.007-.11a.773.773 0 0 0-.147-.451c-.053-.067-.078-.11-.078-.133 0-.024.018-.048.037-.048.007 0 .016.005.027.013.064.048.098.068.115.068.033 0 .062-.08.062-.169a.618.618 0 0 0-.136-.373 2.89 2.89 0 0 1-.08-.1.066.066 0 0 1-.013-.038c0-.028.023-.049.058-.049.025 0 .04.006.082.034a.1.1 0 0 0 .05.02c.052 0 .072-.073.072-.271l-.002-.082-.007-.121c-.008-.142-.02-.167-.08-.167h-.053c-.327 0-.478-.206-.563-.762-.06-.402-.21-.687-.394-.748-.11-.037-.15-.06-.15-.09 0-.018.031-.036.064-.036.024 0 .08.015.126.033.266.108.49.16.687.16.32 0 .572-.235.572-.534 0-.229-.109-.46-.304-.648a.379.379 0 0 0-.167-.1h-.013l-.033.01.014.096.026.067.007.027c0 .015-.014.026-.031.026a.059.059 0 0 1-.049-.028l-.12-.18c-.095-.143-.304-.262-.46-.262-.054 0-.089.025-.089.063 0 .02.019.053.041.079.034.038.061.085.061.106l-.007.027c-.007.015-.017.025-.026.026H6.32c-.032 0-.047-.014-.194-.18-.119-.136-.362-.268-.493-.268a.07.07 0 0 0-.048.021c-.009.01-.014.019-.014.026 0 .02.018.046.047.074.042.037.074.083.074.103 0 .013-.017.025-.037.025-.038 0-.124-.055-.284-.181-.249-.195-.36-.381-.36-.595 0-.258.183-.461.42-.461.138 0 .322.066.448.16l.328.248c.149.113.333.173.525.173.042 0 .081-.009.116-.027.03-.014.047-.033.047-.045 0-.008-.026-.02-.06-.028a.767.767 0 0 1-.28-.12l-.335-.253a2.212 2.212 0 0 0-.261-.181c-.176-.093-.21-.115-.21-.135 0-.01.017-.02.038-.02.018 0 .037.004.059.014l.174.074c.055.023.149.08.28.166.358.24.54.315.75.315.208 0 .346-.14.346-.334 0-.038-.01-.08-.028-.116l-.033-.066c-.012-.023-.034-.041-.04-.033l-.02.026-.02.14c0 .005-.009.022-.02.047a.233.233 0 0 1-.048.067c-.036.036-.067.047-.123.047-.103 0-.22-.055-.531-.255-.316-.201-.602-.307-.828-.307a.867.867 0 0 0-.87.867c0 .669.408.971 1.69 1.25.489.107.703.25.703.466 0 .199-.16.323-.414.323a.937.937 0 0 1-.18-.014c-.043-.009-.273-.07-.689-.188a3.47 3.47 0 0 0-.89-.124c-.504 0-.842.15-1.073.473-.027.039-.053.06-.071.06-.014 0-.034-.008-.056-.027l-.094-.074a.45.45 0 0 0-.24-.091c-.05 0-.098.02-.14.058-.034.03-.059.046-.069.046-.038 0-.106-.085-.158-.194a1.062 1.062 0 0 1-.114-.454c0-.067.021-.113.05-.113.024 0 .041.018.05.053l.053.194c.03.109.09.194.136.194.02 0 .057-.03.098-.08a.304.304 0 0 0 .054-.093c.041-.122.052-.14.085-.14.039 0 .06.024.086.146.005.022.012.056.043.114.028.051.054.092.08.12.02.022.045.035.07.035.059 0 .112-.099.112-.206v-.029l-.009-.124c0-.047.007-.062.035-.062.016 0 .027.008.047.033.028.036.067.069.113.093.041.023.074.034.096.034.02 0 .043-.012.065-.034.018-.017.028-.035.028-.052 0-.019-.024-.05-.094-.12a.857.857 0 0 1-.133-.268c-.018-.053-.044-.088-.063-.088a.21.21 0 0 0-.044.014l-.086.032-.06.027-.023.005c-.028 0-.05-.02-.05-.046 0-.025.06-.097.134-.158a.245.245 0 0 0 .086-.18c.004-.113.026-.201.047-.201l.02-.234a2.34 2.34 0 0 1 .1-.46c.009-.025.02-.041.027-.041.019 0 .036.05.036.105l-.002.035-.004.067c0 .085.013.128.04.128.029 0 .061-.041.09-.116l.06-.153a.359.359 0 0 0 .027-.125c0-.13-.078-.225-.186-.225l-.049.008a.21.21 0 0 1-.046.014c-.036 0-.065-.039-.065-.085l.005-.096-.006-.134-.027-.14-.007-.068-.06.034-.074.06-.107.086-.087.074a.077.077 0 0 1-.05.02c-.05 0-.057-.014-.057-.117v-.027c0-.084-.036-.15-.174-.31a1.362 1.362 0 0 1-.033-.04l-.027.046-.073.12-.073.187-.014.12c-.003.035-.018.061-.03.061-.014 0-.037-.017-.064-.048a.513.513 0 0 0-.287-.193l-.014.047c-.024.08-.037.126-.04.141l-.007.128v.095c0 .037-.014.059-.036.059h-.004l-.04-.035c-.015-.014-.043-.02-.08-.02-.125 0-.204.067-.204.174 0 .08.027.14.15.327.055.084.118.149.143.149.016 0 .03-.044.03-.096l-.012-.08a.322.322 0 0 1-.02-.103c0-.037.012-.058.032-.058.06 0 .122.173.148.415l.027.247a.82.82 0 0 0 .08.267.68.68 0 0 0 .174.247c.064.045.104.09.104.114 0 .02-.018.04-.036.04l-.135-.048-.056-.008c-.133 0-.178.076-.178.306 0 .278.187.677.395.844l.307.248c.157.125.275.332.275.48 0 .196-.215.388-.582.522l-.22.08c-.17.061-.24.172-.307.494a.557.557 0 0 1 .184-.033h.03l.099.003c.09 0 .154-.054.154-.13v-.06c0-.017.026-.042.06-.06l.094-.046.074-.06a.061.061 0 0 1 .038-.015c.02 0 .036.02.036.042a.189.189 0 0 1-.013.06.646.646 0 0 0-.035.23c0 .163.026.251.108.371a.468.468 0 0 1 .02-.086c.014-.034.052-.095.114-.18.101-.141.175-.314.175-.407L3.88 18.3l-.02-.154c0-.027.012-.053.033-.073a.073.073 0 0 1 .046-.019c.029 0 .046.017.068.066.017.038.035.06.048.06.023 0 .07-.061.099-.133a.372.372 0 0 0 .033-.141.239.239 0 0 0-.02-.087.244.244 0 0 1-.022-.076c0-.017.006-.025.028-.044a.058.058 0 0 1 .033-.013c.014 0 .027.005.04.013l.06.04c.02.013.039.02.054.02.027 0 .065-.03.093-.074a.573.573 0 0 0 .095-.19c0-.018-.011-.03-.048-.057-.133-.093-.22-.236-.22-.358 0-.028.006-.06.02-.096l.067-.181.053-.14.02-.008c.022 0 .036.02.036.052a.21.21 0 0 1-.016.077.44.44 0 0 0-.029.127c0 .047.024.074.07.074.034 0 .071-.01.112-.027.202-.087.362-.134.458-.134.092 0 .148.02.243.088.026.017.047.027.062.027.011 0 .027-.01.039-.027a.061.061 0 0 0 .013-.034c0-.024-.014-.055-.04-.087-.035-.043-.048-.068-.048-.095 0-.021.014-.034.035-.034.105 0 .27.33.426.856.123.415.158.457.554.682.335.19.463.377.463.682 0 .305-.083.685-.256 1.188-.054.16-.078.268-.078.356 0 .07.013.14.066.318.024.085.04.137.047.154.008.019.025.053.053.1"
        />
        <path
          fill="#FFE500"
          d="M5.097 20.071c.04-.092.051-.115.127-.227.108-.163.147-.25.147-.328v-.107c0-.1.018-.148.058-.148.014 0 .027.008.036.02l.033.053c.01.018.029.028.047.028.02 0 .056-.026.075-.056a.475.475 0 0 0 .078-.239l-.007-.074-.006-.075c0-.04.016-.058.055-.058.026 0 .037.01.059.06.014.032.033.054.05.054.02 0 .04-.015.057-.04l.053-.081.04-.06.01-.033c0-.018-.014-.035-.05-.06-.124-.09-.178-.227-.187-.475a2.12 2.12 0 0 0-.034-.368 8.59 8.59 0 0 0-.121-.287 1.804 1.804 0 0 1-.08-.24c-.017-.063-.035-.081-.084-.081-.182 0-.319.155-.319.36 0 .12.05.31.142.542.128.325.162.44.162.555 0 .245-.097.353-.437.474-.383.137-.562.334-.628.688l.067-.026c.043-.018.074-.028.094-.034l.106-.026c.092-.023.166-.076.18-.127l.028-.094a.063.063 0 0 1 .04-.047l.06-.026.06-.027.013.027-.026.087a.581.581 0 0 0-.014.156.47.47 0 0 0 .114.338M1.51 13.891c.008.038.012.062.012.075 0 .022-.009.08-.027.173l-.012.135c0 .12.021.247.059.353a.509.509 0 0 1 .042.152l-.002.029c-.006.027-.016.048-.026.048-.013 0-.037-.016-.068-.042a.374.374 0 0 0-.361-.087l.033.075.1.248.14.213.147.1c.015.01.028.024.04.04.014.019.02.034.02.044 0 .012-.01.023-.026.024l-.134.006c-.02 0-.036.013-.036.028 0 .022.019.09.056.2l.067.193.114.107.12.088c.036.025.057.053.057.076 0 .018-.011.036-.023.037l-.067.006c-.023.002-.035.022-.035.054 0 .05.047.14.134.26.104.142.176.187.294.187h.1c.048 0 .078.024.078.061 0 .032-.02.05-.064.06-.093.019-.12.037-.12.08 0 .017.012.042.033.073l.054.074c.044.061.095.102.127.102.019 0 .06-.019.098-.061a.42.42 0 0 1 .216-.147c.232-.059.28-.083.28-.137a.17.17 0 0 0-.025-.076.616.616 0 0 1-.101-.327c0-.084-.021-.142-.052-.142-.012 0-.033.02-.055.054a.299.299 0 0 1-.234.141c-.231 0-.51-.361-.648-.842a1.316 1.316 0 0 1-.049-.36c0-.123.018-.268.049-.41.045-.195.07-.304.073-.327l.01-.09c0-.166-.153-.38-.39-.544"
        />
        <path
          fill="#FFE500"
          d="M1.989 14.82a1.19 1.19 0 0 0-.094.435c0 .078.025.14.057.14.012 0 .025-.013.036-.034l.073-.134c.012-.023.025-.046.048-.082.026-.04.047-.078.047-.1 0-.079-.073-.176-.168-.226M2.725 17.833l.033.034.054.053c.13.135.15.148.212.148.058 0 .18-.033.248-.067.029-.014.047-.032.047-.046 0-.009-.024-.035-.067-.074l-.073-.067c-.056-.05-.138-.097-.178-.097-.076 0-.155.033-.276.117M4.274 19.042c.072.03.097.041.135.067.06.04.095.06.106.066.02.01.057.013.106.013.03 0 .058-.005.081-.013l.142-.053.133-.047c.035-.013.06-.033.06-.051 0-.01-.03-.025-.074-.036a.832.832 0 0 1-.101-.034c-.165-.066-.188-.076-.247-.076a.444.444 0 0 0-.342.163M5.966 20.386c.045-.108.075-.127.227-.135.172-.009.334-.316.334-.524 0-.02-.007-.038-.016-.038-.01 0-.024.008-.045.023-.047.031-.081.05-.1.06l-.193.086a.456.456 0 0 0-.243.367c0 .046.009.084.035.162"
        />
        <path
          fill="#0C0D0D"
          d="m3.08 14.58.066.093a.6.6 0 0 0 .145.104c.02 0 .031-.014.043-.058l.026-.1.007-.112c0-.088-.039-.12-.22-.169-.045-.012-.064-.01-.094-.033a.179.179 0 0 0-.08-.04c-.015 0-.028.007-.028.017l.007.03.034.1.093.166v.001ZM3.794 14.578l-.088.155a4.255 4.255 0 0 1-.033.036h-.007c-.035.001-.07-.08-.074-.164l-.012-.134c.01-.054.043-.079.126-.093a.398.398 0 0 0 .134-.04l.107-.074.011-.002c.018 0 .03.012.03.033l-.001.009-.047.114-.148.16h.002ZM3.62 15.033l.106-.052a.121.121 0 0 1 .051-.015c.052 0 .09.039.09.11 0 .075-.06.178-.14.325-.09.16-.155.269-.223.269-.096 0-.233-.153-.365-.409a.43.43 0 0 1-.051-.186c0-.084.036-.129.108-.129a.14.14 0 0 1 .076.02l.06.041a.311.311 0 0 0 .17.053c.041 0 .082-.01.116-.027"
        />
        <path
          fill="#FFE500"
          d="m3.466 15.194-.074-.013H3.38c-.042 0-.064.023-.064.071 0 .067.053.192.121.29a.064.064 0 0 0 .051.028c.044 0 .074-.082.096-.215l.02-.1.002-.02c0-.04-.012-.054-.046-.054h-.016"
        />
        <path
          fill="#1D1D1B"
          d="M18.383 16.938c.116.155.28.254.415.254.042 0 .114-.01.18-.027a.375.375 0 0 1 .088-.014c.033 0 .046.013.046.042a.46.46 0 0 1-.034.125.575.575 0 0 0-.04.12l-.027.14-.067.12-.093.088-.027.027v.09c0 .163-.047.256-.18.344-.012.006-.027.018-.047.034l-.014.053c-.029.125-.051.202-.066.233a1.4 1.4 0 0 1-.128.187 1.206 1.206 0 0 0-.166.274c-.028.067-.049.086-.093.086-.066 0-.13-.082-.142-.18a.303.303 0 0 1-.034.04l-.079.054-.128.086a.947.947 0 0 0-.107.08l-.073.075c-.013.013-.026.02-.038.02-.034 0-.07-.057-.102-.168l-.067-.22a.743.743 0 0 1-.027-.216c0-.11.007-.15.046-.239a.868.868 0 0 0-.24.047.237.237 0 0 1-.059.013c-.022 0-.035-.015-.035-.04a.45.45 0 0 1 .026-.1l.088-.227c.068-.175.284-.336.457-.336.04 0 .098.012.17.035a.363.363 0 0 0 .101.022c.078 0 .14-.057.14-.128a.1.1 0 0 0-.054-.088c-.011-.006-.092-.03-.24-.074-.113-.033-.169-.075-.295-.22-.091-.106-.127-.137-.16-.137-.026 0-.04.017-.04.047l.006.089.002.041c0 .185-.055.363-.189.607l-.187.34c-.088.162-.127.285-.127.408 0 .134.058.254.133.274l.1.027c.013.004.025.01.034.02.013.013.02.028.02.039 0 .014-.012.036-.033.062-.012.013-.052.065-.12.153-.116.15-.188.205-.328.247-.08.196-.212.31-.447.389l-.027.045c-.079.14-.256.269-.369.269h-.025a.527.527 0 0 1-.234.341c-.09.063-.142.102-.153.113a.29.29 0 0 0-.034.06c-.03.067-.058.094-.095.094-.071 0-.13-.067-.172-.194a.99.99 0 0 0-.06.04 1.35 1.35 0 0 1-.127.086c-.03.016-.109.038-.234.067-.163.039-.306.108-.341.168l-.06.1-.028.01c-.032 0-.07-.045-.086-.104a1.656 1.656 0 0 1-.06-.375c0-.238.078-.391.321-.634v-.058c0-.369.28-.619.695-.619l.067.002.227.013h.021a.553.553 0 0 0 .36-.147c.164-.133.21-.216.21-.366 0-.048-.013-.102-.064-.27a1.112 1.112 0 0 1-.048-.313c0-.276.202-.62.477-.808.071-.05.123-.114.123-.152 0-.015-.008-.027-.018-.027-.017 0-.048.018-.085.052a.771.771 0 0 1-.161.1l-.107.053-.12.047c-.036.014-.056.034-.056.059 0 .015.007.035.016.06a.168.168 0 0 1 .013.05.19.19 0 0 1-.034.078l-.093.153c-.092.15-.158.215-.274.268-.076.22-.184.33-.341.354-.126.254-.238.343-.461.367-.03.099-.085.179-.2.308a.648.648 0 0 0-.087.107c-.052.093-.057.1-.081.1-.03 0-.1-.046-.154-.1a.398.398 0 0 1-.06-.08l-.06-.107c-.019-.035-.04-.05-.064-.05l-.042.003-.148.02a.464.464 0 0 0-.267.154l-.08.12c-.008.013-.02.02-.032.02-.06 0-.096-.132-.096-.35 0-.193.03-.32.095-.412l.187-.26a.185.185 0 0 0 .04-.102c0-.03-.011-.06-.033-.085-.04-.047-.077-.076-.107-.08l-.14-.02c-.025-.004-.035-.01-.035-.021 0-.012.007-.028.022-.046a.645.645 0 0 1 .167-.147c.165-.102.274-.142.385-.142.11 0 .237.041.35.115l.193.127a.166.166 0 0 0 .093.028c.09 0 .158-.053.22-.174a.649.649 0 0 0 .09-.31.415.415 0 0 0-.429-.432.566.566 0 0 0-.347.133.224.224 0 0 0-.067.073l-.053.121c-.013.029-.032.047-.048.047-.034 0-.11-.096-.173-.22a1.495 1.495 0 0 1-.093-.241 1.095 1.095 0 0 1-.057-.334l.01-.18a.675.675 0 0 1-.121-.414.74.74 0 0 1 .048-.235.496.496 0 0 1-.073-.298l.006-.083.02-.094.013-.08c-.064-.084-.082-.141-.147-.434-.036-.166-.058-.238-.087-.28-.013-.02-.02-.034-.02-.04 0-.039.094-.074.2-.074l.095.007a.316.316 0 0 1-.029-.135c0-.083.018-.175.05-.267a.496.496 0 0 0 .042-.163c0-.08-.012-.16-.03-.204l-.053-.133a.19.19 0 0 1-.017-.069c0-.013.01-.018.034-.018.13 0 .38.141.578.327.195.185.26.334.26.609l-.012.146c.182.16.261.292.261.434 0 .105-.033.174-.134.274-.18.178-.22.273-.22.504 0 .354.105.547.301.547.173 0 .305-.187.327-.46l.02-.255c.005-.066.016-.146.034-.24.01-.06.02-.141.02-.175 0-.09-.06-.204-.234-.407-.187-.22-.25-.338-.25-.51 0-.205.141-.355.335-.355.047 0 .072.007.128.037.004-.116.009-.139.075-.301.052-.128.107-.22.134-.22.008 0 .022.01.04.027a.626.626 0 0 0 .087.073l.067.047a.82.82 0 0 1 .06.06.64.64 0 0 1 .207-.34c.094-.092.128-.12.147-.12.014 0 .031.011.047.033l.08.106.114.127c.043.048.059.09.08.207l.067-.04.107-.06a.768.768 0 0 0 .08-.054c.02-.013.034-.02.043-.02.01 0 .023.02.031.048l.04.153.087.174a.33.33 0 0 1 .034.172v.041h.044c.132 0 .245.155.245.335 0 .238-.19.546-.437.708a.55.55 0 0 0-.028.178c0 .531.14.643.956.764.204.03.387.068.548.114l.528.174c.181.06.302.087.396.087.1 0 .154-.028.154-.081 0-.091-.134-.173-.543-.333l-.582-.227c-.591-.232-.87-.591-.87-1.123 0-.618.464-1.082 1.084-1.082.233 0 .461.048.788.167.422.154.444.16.49.16.08 0 .125-.055.137-.173.01-.1.038-.141.093-.141.082 0 .17.076.235.201a.799.799 0 0 1 .086.347c0 .22-.116.364-.327.407a.648.648 0 0 1-.538.277c-.266 0-.398-.053-.852-.337-.162-.103-.231-.127-.35-.127-.16 0-.278.099-.278.233 0 .122.099.202.322.262.132.035.151.045.22.113a.45.45 0 0 1 .11-.016c.218 0 .486.117.711.31.412.128.779.572.779.945 0 .411-.357.781-.756.781-.108 0-.323-.033-.517-.082"
        />
        <path
          fill="#FFE500"
          d="m18.142 18.788.027-.073.027-.095a.588.588 0 0 1 .073-.113.535.535 0 0 0 .103-.332.27.27 0 0 0-.035-.13.152.152 0 0 1-.02-.061c0-.01.004-.02.013-.032a.046.046 0 0 1 .027-.02h.004c.017 0 .046.02.069.046.028.034.053.054.068.054.03 0 .062-.051.08-.128a.603.603 0 0 0 .012-.067.652.652 0 0 0-.06-.186.16.16 0 0 1-.019-.069c0-.023.017-.042.037-.042.02 0 .05.02.088.057.019.017.037.027.051.027.042 0 .072-.043.104-.147a.589.589 0 0 0 .026-.105c0-.02-.008-.03-.023-.03l-.024.002-.079.008a.566.566 0 0 1-.375-.182l-.187-.228a2.366 2.366 0 0 1-.167-.22l-.154-.101c-.025-.016-.04-.037-.04-.054 0-.025.026-.042.064-.042.036 0 .145.039.345.123.192.082.495.149.677.149a.58.58 0 0 0 .582-.572c0-.172-.076-.33-.264-.551-.036-.042-.096-.083-.123-.083-.023 0-.037.017-.037.04 0 .018.007.044.02.075a.173.173 0 0 1 .014.061c0 .03-.011.048-.032.048-.041 0-.086-.07-.122-.19-.043-.149-.13-.237-.334-.34a.727.727 0 0 0-.211-.075c-.014 0-.023.011-.023.03 0 .025.01.052.027.079.03.045.047.088.053.127v.006c0 .027-.013.04-.036.04-.043 0-.053-.01-.15-.16a.786.786 0 0 0-.301-.227.373.373 0 0 0-.114-.028h-.004c-.025 0-.043.011-.043.027 0 .005.01.026.03.06l.01.038c0 .02-.014.037-.032.037-.04 0-.164-.102-.262-.215a.67.67 0 0 1-.174-.4c0-.255.244-.483.518-.483.069 0 .127.012.17.035l.234.12.274.18c.158.104.374.181.505.181a.74.74 0 0 0 .21-.041c.066-.018.106-.044.106-.067l-.003-.005-.024-.014-.147-.012c-.081-.008-.267-.091-.414-.188l-.308-.2-.273-.114c-.02-.008-.035-.021-.035-.034 0-.014.015-.026.032-.026l.076.013.254.075c.064.018.167.065.308.14.279.148.46.213.594.213.154 0 .268-.106.268-.25a.965.965 0 0 0-.026-.19.252.252 0 0 0-.041-.088c-.012-.018-.025-.027-.033-.027-.019 0-.03.02-.03.054l.003.046.003.038c0 .123-.048.167-.184.167-.11 0-.26-.045-.6-.179-.318-.125-.517-.174-.715-.174-.503 0-.944.411-.944.879 0 .404.268.713.817.939l.567.233c.47.194.642.332.642.515 0 .152-.142.25-.363.25-.095 0-.214-.027-.432-.097-.532-.17-.878-.24-1.181-.24-.496 0-.85.136-1.13.433-.038.04-.06.051-.093.051-.022 0-.046-.009-.096-.038a.323.323 0 0 0-.146-.047.245.245 0 0 0-.16.088l-.068.087c-.019.025-.041.04-.059.04-.048 0-.134-.082-.188-.18a.678.678 0 0 1-.067-.175.96.96 0 0 1-.014-.182l.007-.124.02-.134c.01-.064.018-.102.02-.113.006-.017.02-.027.033-.027.035 0 .05.032.05.105l-.002.042v.03c0 .19.074.365.157.365.065 0 .123-.117.17-.348.01-.046.029-.073.051-.073.027 0 .043.035.063.134a.583.583 0 0 0 .1.214c.026.033.054.054.076.054.055 0 .09-.083.117-.275.011-.075.033-.12.059-.12.011 0 .021.004.028.014.005.005.02.029.047.073.016.027.042.05.073.066.034.017.06.026.077.026.022 0 .044-.01.064-.026.029-.027.046-.047.046-.055 0-.01-.013-.03-.04-.06a.639.639 0 0 1-.12-.22c-.028-.073-.047-.124-.06-.153-.01-.024-.022-.04-.033-.047l-.021-.005-.04.005-.14.04-.044.007c-.02 0-.031-.012-.031-.032 0-.018.024-.05.055-.075.168-.134.269-.36.307-.688.022-.2.048-.275.133-.394.018-.025.033-.04.041-.04.027 0 .041.02.041.06a.272.272 0 0 1-.021.094.24.24 0 0 0-.015.08v.026l.015.041.073-.027.08-.094a.491.491 0 0 0 .087-.273.213.213 0 0 0-.053-.154c-.043-.05-.072-.07-.102-.07l-.046.003-.047.003c-.043 0-.066-.013-.066-.04l.012-.05.007-.074-.04-.166-.033-.08-.02-.068-.047.034-.101.06a.312.312 0 0 0-.08.074c-.095.115-.101.121-.14.121-.024 0-.037-.01-.037-.025l.004-.029a.733.733 0 0 0 .02-.138.633.633 0 0 0-.187-.39c-.14.134-.214.281-.214.421v.08c0 .031-.01.048-.03.048h-.003c-.016-.003-.033-.016-.047-.034l-.08-.107a1.162 1.162 0 0 0-.108-.087l-.052-.046-.028.053a.708.708 0 0 0-.093.321c-.003.09-.01.115-.032.115a.099.099 0 0 1-.043-.015c-.101-.057-.11-.06-.154-.06-.12 0-.202.086-.202.212 0 .049.027.124.083.223.061.108.153.208.193.208.011 0 .014-.008.014-.04v-.015l-.006-.114-.013-.087v-.011c0-.026.01-.038.03-.038.06 0 .112.177.158.53.039.31.125.524.26.648.035.032.055.057.055.072 0 .011-.012.022-.026.022a.212.212 0 0 1-.088-.034.144.144 0 0 0-.072-.021c-.067 0-.141.078-.154.161l-.06.38-.047.535c-.01.102.005.237.04.4.03.145.046.25.046.317 0 .4-.249.717-.661.84l-.428.125c-.266.08-.398.255-.434.581.068-.053.09-.063.194-.079l.126-.02a.347.347 0 0 0 .114-.034.514.514 0 0 0 .074-.074l.114-.126c.043-.049.081-.076.104-.076.017 0 .029.017.029.038a.246.246 0 0 1-.047.111.317.317 0 0 0-.049.172c0 .085.023.14.11.262a.456.456 0 0 1 .027-.08c.01-.021.044-.068.1-.14.093-.12.159-.245.16-.301.002-.104.011-.137.037-.137.023 0 .027.005.037.064.002.014.01.028.02.04.016.018.03.027.041.027.008 0 .026-.01.053-.027a.502.502 0 0 0 .107-.093.455.455 0 0 0 .067-.12.437.437 0 0 0 .034-.126v-.086c0-.024.01-.042.021-.042.017 0 .05.034.073.074.015.025.024.034.042.034h.004a.1.1 0 0 0 .06-.028c.082-.08.135-.178.135-.25l-.008-.124-.026-.1v-.009c-.001-.021.014-.038.031-.038.031 0 .064.042.11.141.02.047.04.067.06.067.032 0 .057-.023.12-.115l.06-.086a.117.117 0 0 0 0-.133l-.054-.08a.127.127 0 0 1-.013-.068c0-.09.033-.193.1-.314.05-.087.079-.143.087-.167.01-.028.022-.041.037-.041.01 0 .022.016.022.034l-.006.074v.106c.01.025.025.035.058.035.02 0 .044-.005.069-.013l.167-.06c.04-.015.091-.04.153-.074.262-.146.343-.175.472-.175.077 0 .175.03.317.094a.18.18 0 0 0 .069.02c.02 0 .04-.012.058-.033a.08.08 0 0 0 .02-.05.175.175 0 0 0-.027-.084.312.312 0 0 1-.041-.1c0-.018.011-.03.03-.03.016 0 .04.017.05.036.02.032.072.121.154.268.124.221.286.376.428.407l.293.067c.092.02.114.056.114.169 0 .207-.098.39-.267.5l-.24.154c-.088.054-.162.209-.162.336 0 .082.02.229.047.343l.047-.046.114-.067.1-.101.053-.147.053-.134c.026-.064.057-.107.078-.107.024 0 .037.036.037.102v.019l-.001.025c0 .097.013.138.087.283"
        />
        <path
          fill="#FFE500"
          d="M14.188 20.694c0-.318.114-.456.575-.69.907-.46 1.397-.883 1.397-1.203 0-.065-.021-.16-.081-.36a1.178 1.178 0 0 1-.058-.29c0-.148.122-.372.278-.51l.128-.114c.07-.063.12-.153.12-.21v-.031l-.003-.04c0-.066.026-.09.096-.093l.06-.007a.51.51 0 0 1 .052-.014c.021 0 .043.012.056.034l.032.053.047.053c.015.018.03.028.043.028a.163.163 0 0 0 .05-.02.162.162 0 0 1 .082-.025c.034 0 .053.018.053.058 0 .134-.088.328-.241.536-.256.347-.34.533-.34.756 0 .174.05.327.147.453.017.023.026.04.026.049 0 .018-.016.048-.047.084-.01.014-.025.032-.04.054-.053.077-.089.107-.124.107-.027 0-.051-.021-.063-.054l-.027-.073c-.008-.02-.023-.035-.037-.035-.006 0-.017.011-.03.028a.12.12 0 0 0-.026.073v.114a.226.226 0 0 1-.047.133.539.539 0 0 1-.093.1c-.026.022-.044.033-.053.033-.02 0-.039-.021-.048-.054l-.04-.134c-.007-.02-.02-.034-.034-.034-.023 0-.042.038-.047.094-.013.151-.04.243-.08.28l-.093.087c-.03.028-.065.049-.084.049-.02 0-.036-.009-.043-.023l-.047-.1a.033.033 0 0 0-.03-.02c-.027 0-.046.052-.056.154-.024.24-.074.348-.207.44-.104.075-.127.1-.167.188a.43.43 0 0 1-.081-.267c0-.054.009-.095.027-.127a.287.287 0 0 0 .043-.11c0-.017-.01-.03-.025-.03-.006 0-.018.01-.033.027a.357.357 0 0 1-.087.067c-.12.069-.138.094-.166.227-.039.18-.124.264-.307.3-.227.047-.24.052-.321.127l-.009-.119.003.001ZM13.754 13.804v.165c0 .036-.002.06-.013.11a.538.538 0 0 0 .067.474.5.5 0 0 1 .069.223c0 .027-.011.043-.03.043-.01 0-.023-.007-.032-.02l-.053-.073c-.043-.06-.083-.075-.191-.075l-.116.007c.047.114.061.158.08.234.054.219.062.234.181.342.12.107.13.12.13.16 0 .03-.02.053-.045.053l-.045-.007-.027-.003c-.036 0-.07.067-.07.141a.483.483 0 0 0 .09.25l.067.065a.094.094 0 0 1 .027.068c0 .033-.019.06-.04.06a.162.162 0 0 1-.06-.021.114.114 0 0 0-.047-.013c-.03 0-.044.018-.044.055l.011.1.041.172c.01.039.034.082.073.128a.32.32 0 0 0 .1.08l.135.06c.012.01.02.03.02.053s-.02.047-.045.047c-.008 0-.03-.005-.07-.013l-.068-.006c-.068 0-.072.004-.072.055 0 .034.005.07.014.104l.026.107c.028.113.065.174.105.174.009 0 .025-.01.048-.028a.821.821 0 0 1 .413-.14 1.359 1.359 0 0 1 .386.05c.016 0 .021-.017.022-.076l.015-.12.026-.208.02-.153v-.088c-.025.02-.042.036-.054.047-.114.107-.185.14-.303.14-.307 0-.484-.345-.484-.948 0-.249.037-.6.105-1.003.014-.084.021-.143.021-.185 0-.22-.14-.434-.382-.59"
        />
        <path
          fill="#FFE500"
          d="m14.207 15.3.06-.06.06-.053a.313.313 0 0 0 .09-.205.215.215 0 0 0-.023-.096c-.023-.05-.068-.094-.095-.094-.022 0-.042.054-.051.14l-.013.101-.02.101-.007.1v.068l-.001-.001ZM13.62 18.034c.067.025.083.036.153.12.092.107.144.133.267.133a.319.319 0 0 0 .094-.014l.087-.026.067-.02c.031-.01.054-.024.054-.034 0-.014-.053-.058-.133-.113a1.19 1.19 0 0 0-.161-.093.342.342 0 0 0-.153-.042.49.49 0 0 0-.275.089M14.52 19.914c0-.216.213-.393.471-.393.13 0 .204.026.204.07 0 .035-.056.081-.18.147l-.195.107a2.804 2.804 0 0 1-.293.146l-.007-.077ZM17.24 18.294c.095-.02.127-.044.174-.046l.12.006a.363.363 0 0 0 .08-.054l.094-.066c.134-.091.141-.097.141-.126 0-.037-.054-.055-.167-.055-.21 0-.338.099-.44.342"
        />
        <path
          fill="#0C0D0D"
          d="m15.223 14.226.093.06a.872.872 0 0 0 .133.073c.104.042.14.057.14.097 0 .014-.004.05-.013.076a.421.421 0 0 0-.02.094c-.01.09-.065.114-.1.114-.045 0-.093-.07-.167-.2a1.46 1.46 0 0 1-.107-.268l-.004-.026c0-.017.01-.026.028-.026M16.125 14.458l-.154.155c-.054.072-.054.135-.067.147a.091.091 0 0 1-.047.02h-.01a.068.068 0 0 1-.07-.067l-.006-.113-.007-.114v-.008c0-.043.024-.066.059-.074l.142-.04.146-.074a.25.25 0 0 1 .063-.026c.018 0 .032.017.032.039 0 .009-.005.024-.014.041l-.067.113v.001ZM15.45 14.912l.1.075a.183.183 0 0 0 .09.022c.04 0 .1-.016.157-.043l.088-.04a.134.134 0 0 1 .052-.014c.054 0 .095.056.095.128 0 .098-.07.2-.175.346l-.073.155c-.058.083-.096.113-.144.113-.08 0-.118-.044-.237-.281-.085-.169-.12-.272-.12-.355 0-.07.037-.12.09-.12.021 0 .048-.005.077.014"
        />
        <path
          fill="#FFE500"
          d="m15.537 15.281.007.127c.003.057.051.115.098.115.062 0 .106-.093.129-.234.011-.066.015-.076.015-.093 0-.049-.016-.062-.08-.062h-.035l-.046.001h-.03c-.042 0-.058.032-.058.117"
        />
        <path
          fill="#1D1D1B"
          d="M8.016 12.257h.653v1.34h.768V12.27h1.94v1.327h.769V12.27h.653V8.806h-.747l-.028-.04a.416.416 0 0 0-.36-.202c-.151 0-.272.086-.354.242h-.538a.392.392 0 0 0-.36-.242c-.172 0-.31.088-.381.242h-.58c-.095-.171-.203-.242-.37-.242-.168 0-.278.074-.358.242h-.707v3.45Z"
        />
        <path fill="#E63337" d="M12.543 9.091H8.295v2.912h4.248V9.09Z" />
        <path
          fill="#FFE500"
          d="M8.735 9.757a.202.202 0 1 0 0 .404.202.202 0 0 0 0-.404Z"
        />
        <path
          fill="#1D1D1B"
          d="M8.736 10.189a.23.23 0 1 1 0-.458.23.23 0 0 1 0 .458Zm0-.405a.175.175 0 1 0 0 .35.175.175 0 0 0 0-.35Z"
        />
        <path
          fill="#FFE500"
          d="M12.071 9.757a.202.202 0 1 0 0 .404.202.202 0 0 0 0-.404Z"
        />
        <path
          fill="#1D1D1B"
          d="M12.072 10.189a.23.23 0 1 1-.001-.458.23.23 0 0 1 0 .458Zm0-.405a.175.175 0 1 0 0 .35.175.175 0 0 0 0-.35Z"
        />
        <path
          fill="#FFE500"
          d="M8.735 11.34a.202.202 0 0 0-.202.202c0 .112.094.202.21.202.107 0 .195-.09.195-.202 0-.11-.09-.202-.203-.202Z"
        />
        <path
          fill="#1D1D1B"
          d="M8.743 11.772a.233.233 0 0 1-.237-.229.23.23 0 0 1 .46 0c0 .128-.1.23-.223.23Zm-.007-.404a.175.175 0 0 0-.175.174c0 .097.081.175.182.175a.171.171 0 0 0 .167-.175.175.175 0 0 0-.174-.174Z"
        />
        <path
          fill="#FFE500"
          d="M12.071 11.34a.202.202 0 1 0 0 .405.202.202 0 0 0 0-.405Z"
        />
        <path
          fill="#1D1D1B"
          d="M12.072 11.772a.23.23 0 1 1-.001-.458.23.23 0 0 1 0 .458Zm0-.404a.175.175 0 1 0 0 .349.175.175 0 0 0 0-.35Z"
        />
        <path
          fill="#FFE500"
          d="M9.37 10.727c.274.343.62.512 1.046.512.395 0 .668-.14.988-.512-.32-.327-.617-.464-1.007-.464-.41 0-.782.168-1.028.464Z"
        />
        <path
          fill="#1D1D1B"
          d="M9.572 10.727c.283-.22.52-.31.815-.31.295 0 .52.088.81.317-.253.25-.474.344-.814.344-.302 0-.576-.119-.81-.35Z"
        />
        <path
          fill="#FFE500"
          d="M9.916 10.66a.84.84 0 0 0 .95 0 1.11 1.11 0 0 0-.482-.115.997.997 0 0 0-.468.115Z"
        />
        <path fill="#0C0D0D" d="M12.601 9.24H8.235v.149h4.367V9.24Z" />
        <path
          fill="#1D1D1B"
          d="M12.612 9.398H8.227V9.23h4.385v.167ZM8.245 9.38h4.35v-.131h-4.35v.13Z"
        />
        <path
          fill="#FFE500"
          d="M8.905 9.05v.417c0 .1.079.175.18.175.118 0 .184-.063.184-.175v-.41c0-.16-.065-.258-.169-.258a.21.21 0 0 0-.08.022.243.243 0 0 0-.048.026.165.165 0 0 0-.04.055.241.241 0 0 0-.028.074M10.218 9.393v.074c0 .1.078.175.18.175.118 0 .184-.063.184-.175v-.41c0-.158-.065-.258-.168-.258-.12 0-.197.098-.197.251M11.491 9.05v.417c0 .1.079.175.18.175.118 0 .184-.063.184-.175v-.41c0-.16-.065-.258-.169-.258a.215.215 0 0 0-.08.022.215.215 0 0 0-.048.026.166.166 0 0 0-.04.055.241.241 0 0 0-.028.074M9.208 12.573H8.81v.511h.397v-.511ZM9.208 13.2H8.81v.162h.397V13.2ZM11.917 12.573h-.397v.511h.397v-.511ZM11.917 13.2h-.397v.162h.397V13.2Z"
        />
        <path
          fill="#000"
          d="M27.23 24.09h.997v7.755h-.997V24.09ZM29.742 26.373h.886v.82c.388-.565 1.108-.975 1.895-.975 1.13 0 1.927.73 1.927 1.917v3.71h-.886v-3.522c0-.82-.532-1.307-1.319-1.307-.908 0-1.617.764-1.617 1.784v3.046h-.886V26.373ZM36.218 30.505V27.17h-1.052v-.797h1.052V25.33l.886-.42v1.462h1.562v.797h-1.562v3.357c0 .488.377.676.71.676.232 0 .465-.055.82-.321h.1l-.067.841c-.377.2-.61.278-1.03.278-.853 0-1.418-.543-1.418-1.495l-.001-.001ZM39.243 29.11c0-1.65 1.252-2.892 2.725-2.892s2.647 1.042 2.647 2.681v.443H40.13c.1 1.219 1.064 1.861 1.96 1.861.776 0 1.32-.221 2.05-.886h.088l-.033.963c-.62.466-1.252.72-2.094.72-1.628 0-2.858-1.273-2.858-2.891h.001Zm4.564-.5c-.11-.974-.82-1.661-1.838-1.661-.787 0-1.606.554-1.795 1.662h3.633ZM45.765 26.373h.886v.797c.377-.642.997-.952 1.562-.952.31 0 .609.089.841.255l.055.898h-.1c-.266-.255-.564-.355-.93-.355-.665 0-1.43.454-1.43 1.706v3.124h-.885v-5.473ZM49.988 26.373h.886v.82c.388-.565 1.108-.975 1.895-.975 1.13 0 1.927.73 1.927 1.917v3.71h-.886v-3.522c0-.82-.532-1.307-1.319-1.307-.908 0-1.617.764-1.617 1.784v3.046h-.886V26.373ZM55.754 29.11c0-1.596 1.23-2.892 2.858-2.892.864 0 1.54.41 1.917.842v-.687h.886v5.471h-.886v-.687a2.559 2.559 0 0 1-1.917.842c-1.628 0-2.858-1.296-2.858-2.891v.002Zm4.83 0c0-1.142-.754-2.094-1.972-2.094-1.219 0-1.972.952-1.972 2.094 0 1.14.753 2.093 1.972 2.093 1.218 0 1.971-.952 1.971-2.093ZM63.292 30.505V27.17H62.24v-.797h1.052V25.33l.886-.42v1.462h1.563v.797h-1.563v3.357c0 .488.377.676.71.676.233 0 .465-.055.82-.321h.1l-.067.841c-.377.2-.61.278-1.03.278-.853 0-1.418-.543-1.418-1.495v-.001ZM66.537 24.712c0-.344.276-.62.62-.62s.62.276.62.62c0 .343-.276.62-.62.62a.618.618 0 0 1-.62-.62Zm.177 1.66h.886v5.473h-.886v-5.472ZM68.676 29.11c0-1.696 1.263-2.892 2.869-2.892 1.606 0 2.869 1.196 2.869 2.892 0 1.695-1.262 2.891-2.87 2.891-1.606 0-2.868-1.196-2.868-2.891Zm4.852 0c0-1.252-.853-2.094-1.983-2.094-1.13 0-1.983.842-1.983 2.094 0 1.252.853 2.093 1.983 2.093 1.13 0 1.983-.841 1.983-2.093ZM75.543 26.373h.886v.82c.388-.565 1.108-.975 1.895-.975 1.13 0 1.927.73 1.927 1.917v3.71h-.887v-3.522c0-.82-.531-1.307-1.318-1.307-.908 0-1.617.764-1.617 1.784v3.046h-.886V26.373ZM81.309 29.11c0-1.596 1.23-2.892 2.858-2.892.863 0 1.54.41 1.916.842v-.687h.886v5.471h-.886v-.687a2.559 2.559 0 0 1-1.916.842c-1.629 0-2.858-1.296-2.858-2.891v.002Zm4.83 0c0-1.142-.753-2.094-1.971-2.094-1.22 0-1.972.952-1.972 2.094 0 1.14.753 2.093 1.972 2.093 1.218 0 1.971-.952 1.971-2.093ZM88.38 23.87h.887v7.976h-.886v-7.977ZM93.5 24.09h4.431v.842h-3.434v2.504h3.312v.841h-3.312v2.725h3.478v.841H93.5V24.09ZM98.687 29.11c0-1.651 1.252-2.892 2.88-2.892.841 0 1.562.398 1.938.875V23.87h.886v7.977h-.886v-.742A2.584 2.584 0 0 1 101.5 32c-1.562 0-2.814-1.24-2.814-2.891Zm4.874 0c0-1.142-.776-2.094-1.994-2.094-1.219 0-1.994.952-1.994 2.094 0 1.14.775 2.093 1.994 2.093 1.218 0 1.994-.952 1.994-2.093ZM105.766 30.084v-3.71h.886v3.522c0 .82.531 1.307 1.318 1.307.909 0 1.617-.764 1.617-1.784v-3.045h.886v5.472h-.886v-.82c-.387.564-1.108.974-1.894.974-1.131 0-1.927-.73-1.927-1.917v.001ZM111.604 29.11c0-1.795 1.351-2.892 2.857-2.892.665 0 1.219.2 1.585.488l.033.886h-.099c-.477-.41-.898-.576-1.518-.576-1.173 0-1.971.886-1.971 2.094 0 1.207.719 2.093 1.971 2.093.61 0 1.02-.165 1.495-.576h.1l-.033.886c-.366.299-.898.488-1.563.488-1.55 0-2.857-1.097-2.857-2.891ZM116.781 29.11c0-1.596 1.23-2.892 2.858-2.892.864 0 1.54.41 1.917.842v-.687h.886v5.471h-.886v-.687a2.56 2.56 0 0 1-1.917.842c-1.628 0-2.858-1.296-2.858-2.891v.002Zm4.83 0c0-1.142-.753-2.094-1.972-2.094-1.218 0-1.972.952-1.972 2.094 0 1.14.754 2.093 1.972 2.093 1.219 0 1.972-.952 1.972-2.093ZM124.318 30.505V27.17h-1.052v-.797h1.052V25.33l.886-.42v1.462h1.562v.797h-1.562v3.357c0 .488.377.676.709.676.233 0 .466-.055.819-.321h.1l-.066.841c-.377.2-.61.278-1.031.278-.852 0-1.417-.543-1.417-1.495v-.001ZM127.564 24.712a.619.619 0 1 1 1.24 0 .619.619 0 1 1-1.24 0Zm.177 1.66h.887v5.473h-.887v-5.472ZM129.703 29.11c0-1.696 1.262-2.892 2.869-2.892 1.607 0 2.869 1.196 2.869 2.892 0 1.695-1.262 2.891-2.869 2.891-1.607 0-2.869-1.196-2.869-2.891Zm4.852 0c0-1.252-.853-2.094-1.983-2.094-1.13 0-1.983.842-1.983 2.094 0 1.252.853 2.093 1.983 2.093 1.13 0 1.983-.841 1.983-2.093ZM136.57 26.373h.887v.82c.387-.565 1.107-.975 1.894-.975 1.13 0 1.927.73 1.927 1.917v3.71h-.886v-3.522c0-.82-.532-1.307-1.318-1.307-.909 0-1.617.764-1.617 1.784v3.046h-.887V26.373Z"
        />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="#fff" d="M0 0h190v32H0z" />
        </clipPath>
      </defs>
    </svg>
  ),
};
export const internalOrgs = [
  "DEV_CA001",
  "QA_CA001",
  "2c5422b4-4ccf-4ee7-a4a1-e59fbea2b72e",
];
export const reportMakerQual = [
  {
    id: "AS & A Level",
    value: "AS & A Level",
  },
  {
    id: "IGCSE",
    value: "IGCSE",
  },
  {
    id: "ADIP",
    value: "ADIP",
  },
];
export const getRecentExamSeries = () => {
  const date = new Date();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();

  let labels = [];

  if (month < 7) {
    labels = [`June ${year}`, `November ${year - 1}`, `June ${year - 1}`];
  } else if (month < 12) {
    labels = [`November ${year}`, `June ${year}`, `November ${year - 1}`];
  } else {
    labels = [`June ${year + 1}`, `November ${year}`, `June ${year}`];
  }
  return labels.map(label => ({ id: label, value: label }));
};

export const splitDateTime = dateTimeStr => {
  const [datePart, timePart, format] = dateTimeStr.split(" ");
  return {
    date: datePart,
    time: timePart.slice(0, 5),
    format: format,
  };
};

export const isFirstDateGreaterThanSecond = (currentDate, previousDate) => {
  let currentMoment = moment(currentDate, "DD-MM-YYYY HH:mm");
  let previousMoment = moment(previousDate, "DD-MM-YYYY HH:mm");
  return currentMoment.isAfter(previousMoment);
};

export const convertDatesToBST = dateTimeStr => {
  return moment
    .tz(dateTimeStr, "YYYY-MM-DD HH:mm A", "UTC")
    .tz("Europe/London")
    .format("DD-MM-YYYY HH:mm A");
};

export const transformResponseToBST = dateTime => {
  if (!dateTime) return null;

  const bstDateAndTime = splitDateTime(convertDatesToBST(dateTime));
  return bstDateAndTime;
};

export const convertBSTToUTC = dateTimeStr => {
  return moment
    .tz(dateTimeStr, "DD-MM-YYYY HH:mm A", "Europe/London")
    .tz("UTC")
    .format("YYYY-MM-DDTHH:mm:ss[Z]");
};

export function convertTo12HourFormat(dateTimeStr) {
  if (!dateTimeStr) return "";
  const cleaned = dateTimeStr.replace(/\s*(AM|PM)$/i, "");
  const parsed = moment(cleaned, "DD-MM-YYYY HH:mm", true);
  if (!parsed.isValid()) {
    console.error("Invalid date format. Expected 'DD-MM-YYYY HH:mm'.");
    return "";
  }
  return parsed.format("DD-MM-YYYY hh:mm A");
}

export const exportToExcel = (data, fileName = "download-exception.xlsx") => {
  const formattedData = data.map(item => {
    const bst = transformResponseToBST(item?.results_release_time);
    return {
      "Series": item.series,
      "Qualification": item.detailed_qualification,
      "Centre ID": item.centreid,
      "Result Release Time (BST)": `${bst.date} ${bst.time} ${bst.format}`,
    };
  });
  const worksheet = XLSX.utils.json_to_sheet(formattedData);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

  const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
  const blob = new Blob([excelBuffer], {
    type:
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8"
  });
  saveAs(blob, fileName);
};

export const lockScrollPosition = () => {
  const scrollY = window.scrollY;
  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollY}px`;
  document.body.style.left = "0";
  document.body.style.right = "0";
  return scrollY;
};

export const unlockScrollPosition = (scrollY) => {
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.left = "";
  document.body.style.right = "";
  window.scrollTo(0, scrollY);
};